"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  system: {
    user: {
      bView: 'View',
      bEdit: 'Edit',
      bDelete: 'Delete',
      bBind: 'Bind Google Code',
      userManagement: "User Management",
      username: "Username",
      status: "Status",
      query: "Search",
      add: "Add",
      delete: "Delete",
      resetPassword: "Reset Password",
      unauthorized: "Unauthorized",
      optionTip: "Please Select",
      optionDisable: "Disable",
      optionValid: "Valid",
      inputPlaceholder: "Please Select",
      placeholder: "Username",
      statusPlaceholder: "Status",
      table: {
        username: "Username",
        sex: "Gender",
        department: "Department",
        mobile: "Mobile",
        email: "Email",
        userStatus: "User Status",
        loginFaildCount: "Login Failed Count",
        createTime: "Create Time ",
        operation: "Operation",
        detail: {
          userInfo: "User Information"
        },
        del: {
          deletedUser: "Delete User",
          confirmDelete: "Confirm the deletion of this user?"
        },
        edit: {
          updateUser: "Edit User Information",
          submit: "Submit",
          cancel: "Cancel"
        },
        google: {
          bindCode: "Google Verification Code",
          confirm: "Confirm",
          cancel: "Cancel"
        }
      },
      userTable: {
        newUsers: "New Users",
        submit: "Submit",
        reset: "Reset",
        deleteWarn: "Please select the user to be deleted",
        deletedUser: "Delete User",
        confirmDelete: "Confirm the deletion of this user?",
        resetWarn: "Please select the user who needs to reset the password",
        resetSuccess: "The selected user password has been reset to 1234Qwer",
        resetSuccessInfo: ', please modify after the first login！'
      },
      treeSelect: {
        placeholder: "Please Select"
      },
      deleteUsers: {
        warn: "The selected user contains the currently logged in user and cannot be deleted",
        success: "User deleted successfully"
      }
    },
    userAdd: {
      username: "Username",
      mobile: "Mobile",
      email: "Email",
      role: "Role",
      department: "Department",
      status: "Status",
      statusInput: {
        valid: "Valid",
        disable: "Disable"
      },
      gender: "Gender",
      sexInput: {
        male: "Male",
        female: "Female",
        secret: "Confidential"
      },
      remark: "Remark",
      treeSelect: {
        placeholder: "Please Select"
      },
      formSelects: {
        error: "Failed to get the role list"
      },
      userAddFormSubmit: {
        success: "The user is added successfully, the initial password is 1234Qwer"
      }
    },
    role: {
      viewRole: "View Role",
      layTitle: "Role management",
      roleName: "Name",
      query: "Search",
      createRole: "Create Role",
      roleID: "Role ID ",
      roleNameHeader: "Name",
      roleDescription: "Description",
      rolePermission: "Permission",
      submitButton: "Submit",
      noPermission: "Unauthorized",
      addRoleButton: "Add",
      deleteRoleButton: "Delete",
      deleteRoleText1: "Please select the character to be deleted...",
      deleteRoleText2: "Delete Role",
      deleteRoleText3: "Are you confirmed to delete the selected character?",
      deleteRoleText4: "Delete Role successfully",
      editRoleText1: "Edit Role",
      editRoleText2: "Edit Role successfully",
      createRoleText1: "Create Role successfully",
      hintsText: "Hints",
      noPermissionConfirmText: "The character is not own any permissions, do you want to continue?",
      createTimeText: "Create Time",
      operationText: "Operation",
      placeholder: "Role name"
    },
    menu: {
      menuManagement: "Menu Management",
      nameHeader: "Name",
      queryText: "Search",
      addMenu: "New Menu",
      parentMenuID: "Parent ID",
      menuName: "Name",
      menuType: "Type",
      menuType1: "Menu",
      menuType2: "Button",
      menuIcon: "Icon",
      menuPermission: "Permission",
      menuListOrder: "List Order",
      submitButton: "Submit",
      warningText1: "Select one parent node only",
      warningText2: "Select button as parent is not allowed",
      warningText3: "Please select menus or buttons to be deleted",
      warningText4: "No data is changed",
      hintsText: "Hints",
      deleteConfirmText: "Once you click the confirm button, these records will be deleted, the child records of those selected records will also be deleted",
      deleteSuccessText: "Delete successfully",
      menuInformationExcel: "MenuInformation.xlsx",
      addText: "Add",
      deleteText: "Delete",
      exportExcelText: "Export Excel",
      editMenuText: "Edit Menu",
      editButtonText: "Edit Button",
      selectIconText: "Select Icon",
      confirmText: "Confirm",
      addButtonText: "Add Button",
      editText: "Edit",
      editSuccessText: "Edit successfully",
      addSuccessText: "Add successfully",
      placeholder: "Menu name"
    },
    dept: {
      department: "Department",
      layTitle: "Department Management",
      name: "Name",
      query: "Search",
      formHeader: "New Department",
      parentDepartmentID: "Parent ID",
      departmentName: "Name",
      departmentSort: "Sort",
      submit: "Submit",
      eleTreeHeaderText: "Edit Department",
      dropdownAddWarnText: "Only one node can be selected as the parent!",
      dropdownDeleteWarnText: "Please tick the department to be deleted!",
      dropdownDeletePromptText: "Prompt",
      dropdownDeleteInfoText: "When you click the OK button, these records will be completely deleted, if they contain sub-records, they will also be deleted!",
      dropdownDeleteSuccessText: "Deleted Successfully!",
      dropdownExportText: "DeptInfoForm.xlsx",
      optionAdd: "New department",
      optionDelete: "Delete department",
      optionExport: "Export Excel",
      resetText: "New department",
      formSubmitEditText: "Edit",
      formSubmitWarnText: "The data has not been modified",
      formSubmitEditSuccessText: "Edit successfully",
      formSubmitAddSuccessText: "Add successfully",
      placeholder: "Department name",
      deptName: "Department name"
    },
    codeSortUpdate: {
      dictionaryCategoryId: "Dictionary Category ID",
      categoryName: "Name",
      categoryCode: "Code",
      parentCode: "Parent Code",
      description: "Description",
      remark: "Remark",
      dateCreated: "Date Created",
      operationText: "Operation",
      updateFormWarnText: "The data has not been modified",
      updateFormSuccessText: "Edit data successfully!"
    },
    codeSortAdd: {
      categoryName: " Name",
      categoryCode: "Code",
      parentCode: "Parent Code",
      description: "Description",
      remark: "Remark",
      addFormSuccessText: "Successfully added dictionary category"
    },
    codeSort: {
      layTitle: "Dictionary Category",
      categoryName: "Name",
      query: "Search",
      tableAddOpenText: "New Dictionary Category",
      tableAddBtnConfirmText: "Submit",
      tableAddBtnResetText: "Reset",
      toolBarDeleteWarnText: "Please select the dictionary category to be deleted",
      toolBarDeleteConfirmTex: "Delete dictionary category",
      toolBarDeleteConfirmInformation: "Confirm to delete the dictionary category?",
      toolDelConfirmText: "Delete dictionary category",
      toolDelConfirmInformation: "Confirm to delete the dictionary category?",
      toolEditOpenText: "Edit Dictionary Category",
      toolEditBtnConfirmText: "Submit",
      toolEditBtnResetText: "Cancel",
      iniTableCodeTitle: "Code",
      iniTableNameTitle: "Name",
      iniTableRemarkTitle: "Remark",
      iniTableCreateTimeTitle: "Create Time",
      iniTableOperationTitle: "Operation",
      deleteCodeSortsSuccessText: "Delete the dictionary category successfully",
      placeholder: "Category name",
      categoryCode: "category name"
    },
    code: {
      layTitle: "Dictionary Management",
      parentCode: "Parent Code",
      code: "Code",
      codeName: "Name",
      query: "Search",
      toolBarAddOpenText: "New Dictionary",
      toolBarAddBtnSubmitText: " Submit",
      toolBarAddBtnResetText: "Reset",
      toolBarDeleteWarnText: "Please select the dictionary to be deleted",
      toolBarDeleteConfirmText: "Delete Dictionary",
      toolBarDeleteConfirmInformation: "Confirm to delete the dictionary?",
      toolBarLoadReapplicationConfirmText: "Confirm to refresh the cache",
      toolBarLoadReapplicationConfirmInformation: "Confirm to refresh the cache?",
      toolBarLoadReapplicationSuccessText: "Refresh the cache successfully",
      toolBarGatewayLoadConfigCacheConfirmText: "Confirm to refresh the cache",
      toolBarGatewayLoadConfigCacheConfirmInformation: "Confirm to refresh the cache of all gateway servers?",
      toolBarGatewayLoadConfigCacheSuccessText: "Refresh the gateway server cache successfully",
      toolBarMerchLoadConfigCacheConfirmText: "Confirm to refresh the cache",
      toolBarMerchLoadConfigCacheConfirmInformation: "Confirm to refresh the cache of all Merchant servers?",
      toolBarMerchLoadConfigCacheSuccessText: "Refresh the Merchant server cache successfully",
      toolBarAgentLoadConfigCacheConfirmText: "Confirm to refresh the cache",
      toolBarAgentLoadConfigCacheConfirmInformation: "Confirm to refresh the cache of all Agent servers?",
      toolBarAgentLoadConfigCacheSuccessText: "Refresh the Agent server cache successfully",
      codeTableDelConfirmText: "Delete Dictionary",
      codeTableDelConfirmInformation: "Confirm to delete the dictionary?",
      codeTableEditOpenText: "Edit Dictionary",
      codeTableEditBtnSubmitText: "Submit",
      codeTableEditBtnCancelText: "Cancel",
      initTableSortCodeTitle: "Sort Code",
      initTableCodeTitle: "Code",
      initTableNameTitle: "Name",
      initTableParentCodeTitle: "Parent Code",
      initTableDescriptionTitle: "Description",
      initTableRemarkTitle: "Remark",
      initTableCreateTimeTitle: "Create Time",
      initTableOperationTitle: "Operation",
      deleteCodeSuccess: "Dictionary deleted successfully",
      placeholder: "Keyword",
      cache: "Cache",
      gatewayCache: "Gateway Cache",
      organizationCache: "Organization Cache",
      organizationSendCache: "Organization Send Cache",
      proxyCache: "Agent Cache",
      cacheRefreshed: 'Cache has been refreshed',
      agentCacheRefreshed: 'Agent cache is refreshed',
      merchantCacheRefreshed: 'Merchant cache is refreshed',
      gatewayCacheRefreshed: 'Gateway cache is refreshed',
      dictionaryName: "Dictionary Name",
      dictionaryCategory: "Dictionary Category"
    },
    codeAdd: {
      dictionaryName: "Name:",
      code: "Code: ",
      parentCode: "Parent Code:",
      dictionaryCategory: "Category:",
      description: "Description:",
      remark: "Remark:",
      formSelectsErrorText: "Failed to get the dictionary category list",
      codeAddFormSuccessText: "Added dictionary successfully"
    },
    codeUpdate: {
      dictionaryI: "Dictionary ID:",
      dictionaryName: "Name:",
      code: "Code: ",
      parentCode: "Parent Code:",
      dictionaryCategory: "Category:",
      description: "Description:",
      remark: "Remark:",
      formSelectsErrorText: "Failed to get the dictionary category list",
      codeUpdateFormWarnText: "The data has not been modified!",
      codeUpdateFormSuccessText: "Edit dictionary successfully"
    },
    areaNumber: {
      layTitle: "Area Code",
      areaName: "Area name",
      query: "Search",
      toolbarAreaNumberTableAddOpenText: "Add area code",
      toolbarAreaNumberTableAddBtnSubmitText: "Submit",
      toolbarAreaNumberTableAddBtnResetText: "Reset",
      toolbarAreaNumberTableDeleteWarnText: "Please select the area code to be deleted",
      toolbarAreaNumberTableDeleteConfirmText: "Delete area code",
      toolbarAreaNumberTableDeleteConfirmInformation: "Confirm to delete the area code?",
      toolbarAreaNumberTableDelConfirmText: "Delete area code",
      toolbarAreaNumberTableDelConfirmInformation: "Confirm to delete the area code",
      toolAreaNumberTableEditOpenText: "Edit area code",
      toolAreaNumberTableEditBtnSubmitText: "Submit",
      toolAreaNumberTableEditBtnCancelText: "Cancel",
      initTableAreaTitle: "Area name",
      initTableAreaNoTitle: "Area code",
      initTableCreateTime: "Create time",
      initTableOperation: "Operation",
      deleteCodeSortsSuccessText: "Delete the dictionary category successfully",
      placeholder: "Area name"
    },
    areaNumberAdd: {
      areaName: "Name:",
      areaCode: "Code:",
      userAddFormSuccessText: "Add area number successfully"
    },
    areaNumberUpdate: {
      areaCodeId: "Area Code Id:",
      areaName: "Name:",
      areaCode: "Code:",
      FormSubmitWarnText: "The data has not been modified!",
      FormSubmitSuccessText: "Edit data successfully"
    }
  },
  dashboard: {
    lineChartTitle: 'Submit Success Rate Latest Seven Days',
    receiveSuccess: "SMS: Received",
    rechargeAmount: "Amount Recharged",
    waitForSubmitting: "SMS: Submitting",
    // submitSuccess: "SMS: Submitted",
    queryApiTimes: "Query Api Times Today",
    totalPayAmount: "Total Pay Amount Today",
    rechargeSuccess: "Pay Success Time Today",
    submitSuccess: "Submit Success Time Today",
    rateSuccessForSevenDays: "Submit Success Rate For Latest Seven Days",
    rateSuccess: "Submit Success Rate",
    receiptSuccessForSevenDays: "Receipt Success Rate For Latest Seven Days",
    receiptSuccess: "Receipt Success Rate",
    payAmount: "Total Amount Paid",
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
    sun: "Sun",
    top5SuccessRate: "Highest Success Rate Organization",
    top6Channels: "Highest Channels According to Success Rate",
    top5PayCurrency: "Current Payment Amount In Each Currency For Today",
    top5FailureRate: "Highest Failure Rate Organization",
    successRate: "Success Rate",
    failureRate: "Failure Rate",
    top10SmsCount: "The Top Ten Organizations With The Highest Total Payments Yesterday",
    top10SmsCountTotal: "Total Consume Amount",
    top10Agent: "Agents with Highest Recharge",
    top10PaymentYesterday: 'The Most Payment Yesterday',
    goodAfternoon: 'Good Afternoon',
    lastLoginTime: 'Last Login Time',
    lastLoginIp: 'Last Login IP',
    welcome: 'Welcome',
    moneyUnit: 'RMB',
    agent: {
      agentLabel: 'Agent Name',
      sendSMSTotal: 'Total SMS Sent',
      numOfOrgs: 'Active Organizations \n (Within 10 days)',
      smsUnit: 'SMS',
      orgUnit: 'Orgs',
      availableQuota: 'Available Quota',
      rechargeTotal: 'Total Recharge',
      overall: 'Overall',
      availableProfit: 'Available Profit',
      totalConsumption: 'Total Consumption',
      queryAPIToday: 'Query API Today',
      paySuccessToday: 'Pay Success Today',
      enterpriseRechargeTotal: 'Total Organization Recharge',
      SmsSent: 'SMS Sent',
      successTotal: 'Total Success',
      today: 'Today',
      profit: 'Profit',
      cost: 'Cost',
      top5Orgs: 'Organizations with Highest SMS Quantity',
      top10Orgs: 'Top ten organization in total payment'
    },
    merchant: {
      normal: "Normal",
      blocked: "Blocked",
      unsuccessful: "Unsuccessful",
      approved: "Approved",
      notApproved: "Not Approved",
      redirectToDocs: 'Go to docs',
      availableBalance: 'Available Balance',
      moneyUnit: 'dollor',
      consumptionAmount: 'Consumption Amount',
      frozenAmount: 'Frozen Amount',
      uncreditedAmount: 'Uncredited Amount',
      totalSMSSent: 'Total SMS Sent',
      totalRecharge: 'Total Recharge',
      smsUnit: 'SMS',
      companyInformation: 'Company Information',
      organizationName: 'Organization Name',
      organizationStatus: 'Organization Status',
      approvalStatus: 'Approval Status',
      organizationCode: 'Organization Code',
      md5Key: 'MD5 Key',
      accessNumber: 'Access Number',
      accessCode: 'Access Code',
      numberOfConnections: 'Number of Connections',
      channelRate: 'Channel Rate',
      goToDocs: 'Documentation',
      HTTPAPIText: 'HTTP API',
      SMPPAPIText: 'SMPP API',
      top5SmsSent: '5 Previous days of Successfully Sent Messages',
      top5Pay: '5 Previous days of Successfully Payment',
      numSuccesses: 'Number of successes'
    }
  },
  common: {
    admin: "admin user",
    agent: "agent user",
    merchant: "merchant user",
    currencyType: 'Currency Type',
    HKD: 'Hong Kong dollar',
    USD: 'United States dollar',
    CNY: 'Chinese yuan',
    noData: 'No Data',
    emailFormat: 'Email format is not correct',
    withdraw: "Withdraw",
    networkError: "Network Error",
    warning: "Warning",
    required: "Required",
    success: "Success",
    error: "Error",
    fetchError: "Fetch Error",
    examinationPassed: "Approved",
    auditNotPassed: "Not Approved",
    QRCode: "QR Code",
    permission: "Permission",
    userAuthorityManagement: "Permission Management",
    newTariff: "Add Cost",
    cost: "Netway Configuration",
    addNew: "Create",
    update: "Edit",
    resetPassword: "Reset Password",
    batchLock: "Batch Lock",
    batchUnlock: "Batch Unlock",
    invalid: "Invalid",
    reject: "Reject",
    approve: "Approve",
    recharge: "Recharge",
    return: "Return",
    add: "Add",
    edit: "Edit",
    delete: "Delete",
    search: "Search",
    stop: "Stop",
    buildAndStart: "Build And Start",
    import: "Import",
    export: "Export",
    exportNumber: "Export Number",
    exportAreaReport: "Export Area Report",
    exportBrokenNumber: "Export Broken Number",
    checkNumberList: "Check Number List",
    exportDailyReport: "Export Daily Report",
    exportMonthlyReport: "Export Monthly Report",
    addPreviousDailyReport: "Add Daily Report",
    addPreviousMonthlyReport: "Add Monthly Report",
    uploadNumberPool: "Upload Number Pool",
    deleteNumberPool: "Delete Number Pool",
    createTime: "Create Time",
    creator: "Creator",
    updateTime: "Update Time",
    editor: "Editor",
    remark: "Remark",
    oldPassword: "Old Password",
    password: "Password",
    confirmPassword: "Confirm Password",
    submit: "Submit",
    reset: "Reset",
    cancel: "Cancel",
    confirm: "Confirm",
    updateMerchant: "Update Merchant",
    uploadedMerchant: "Uploaded Merchant",
    uploadMerchant: "Upload Merchant",
    showImage: "Show Image",
    queryKid: "Check Id",
    queryAgent: "Check Agent",
    queryMerchant: "Check Merchant",
    queryReviewAccount: "Check Review Account",
    updateAdmin: "Update Admin",
    refuse: "Reject",
    changePwd: "Change Password",
    updateStatus: "Update Status",
    forceChangePwd: "Force Change Password",
    resetMFASecret: "Reset Google Auth",
    resetPwd: "Reset Password",
    frozen: "Frozen",
    restore: "Restore",
    fromTime: "From Time",
    toTime: "To Time",
    fromData: "From Date",
    toDate: "To Date",
    checkDailyReportData: "Check Present Daily Report",
    reportExportText: "Report Export",
    viewStatisticText: "View Statistic",
    date: "Date",
    time: "Time",
    uploadDocumentMessage: "Upload Document",
    usernameText: "Username",
    contentText: "Content",
    batchNumber: "Batch Number",
    operator: "Platform",
    statusText: "Status",
    operationText: "Operation",
    start: "Start",
    pause: "Pause",
    toText: "To",
    createTimeText: "Create Time",
    lockTimeText: "Lock Time",
    pleaseEnterText: 'Please Enter',
    pleaseSelectText: 'Please Select',
    pleaseClickText: "Please Click",
    batchDeleteText: "Batch Delete",
    batchUpdatePermissionText: "Batch Update Permission",
    systemWarning: 'System Warning',
    noPermissionWarning: "You have no permission to access this resources, please contact administrator",
    goBack: 'Go Back',
    invalidTokenWarning: "Token has been expired or the account is logged in elsewhere",
    login: 'Login',
    cancelUser: "Cancel",
    clickToShowImage: "Image",
    notedText: "Noted",
    closedText: "Closed",
    previewText: "Preview",
    remarkText: "Remark",
    forceText: "Force",
    notForceText: "Not Force",
    callbackDown: "Callback",
    regetNotify: "Get Notify",
    notifyDetail: "Notify Detail",
    unknownText: "Unknown"
  },
  route: {
    organizationRechargeManagement: 'Recharge Management',
    channelOperatorDailyReport: 'Channel Operator Daily Report',
    channelOperatorMonthlyReport: 'Channel Operator Monthly Report',
    bindGoogleCode: 'Bind Google Code',
    payPasswordUpdate: 'Change Payment Password',
    personalAccountManagement: 'Account Management',
    passwordUpdate: 'Update Password',
    channelNumberPoolManagement: 'Number Pool Management',
    batchSuccessRate: 'Batch Success Rate',
    exportedExcel: 'Export Excel',
    totalDailyReport: 'Total Daily Report',
    generalDailyReport: 'General Daily Report',
    allConsumeAmountDailyReport: 'All Cost Daily Report',
    allConsumeAmountMonthlyReport: 'All Cost Monthly Report',
    consumeAmountDailyReport: 'Cost Detail Daily Report',
    consumeAmountMonthlyReport: 'Cost Detail Monthly Report',
    agentDailyReport: 'Agent Daily Report',
    organizationDailyReport: 'Organization Daily Report',
    systemManagement: 'System Management',
    userManagement: 'User Management',
    menuManagement: 'Menu Management',
    departmentManagement: 'Department Management',
    dictionaryCategory: 'Dictionary Category',
    dictionaryManagement: 'Dictionary Management',
    regionManagement: 'Region Management',
    loginBlackList: "Login Black List",
    agentManagement: 'Agent Management',
    agentCost: "Agent Netway Configuration",
    agentPermission: 'Agent Permission',
    agentSettings: 'Agent Settings',
    agentBlackList: "Agent Black List",
    organizationManagement: 'Organization Management',
    organizationCost: "Organization Netway Configuration",
    organizationUserPermission: 'Organization User Permission',
    organizationOperationLog: 'Organization Operation Log',
    organizationBlacklist: "Organization Black List",
    organizationUserSettings: 'Organization User Settings',
    financeManagement: 'Finance Management',
    agentConversionQuotaList: 'Agent Conversion Quota List',
    agentRechargeOrder: 'Agent Recharge Order',
    organizationRechargeOrder: 'Organization Recharge Order',
    organizationMonthlyReport: 'Organization Monthly Report',
    reportManage: 'Report Management',
    agentMonthlyReport: 'Agent Monthly Report',
    channelDailyReport: 'Channel Daily Report',
    agentRemitOrder: 'Agent Withdrawal Order',
    agentRemitOrderReport: 'Agent Remit Order Report',
    organizationRemitOrder: "Organization Remit order",
    organizationRemitOrderReport: 'Organization Remit Order Report',
    amountChangeRecord: 'Amount Change Record',
    organizationAmountChangeRecord: 'Organization Amount Change Record',
    organizationAmountChangeRecordReport: 'Organization Amount Change Record Report',
    agentAmountChangeRecord: 'Agent Amount Change Record',
    agentAmountChangeRecordReport: 'Agent Amount Change Record Report',
    organizationUserManagement: 'Organization User Management',
    channelMonthlyReport: 'Channel monthly report',
    orderManagement: "Order Management",
    orderRecords: "Recharge Order Records",
    orderRecordsReport: "Recharge Order Records Report",
    orderNotify: "Recharge Order Notify",
    orderNotifyReport: "Recharge Order Notify Report",
    refundOrder: "Refund Order Records",
    refundOrderReport: "Refund Order Records Report",
    orderHistoryManagement: "Order History Management",
    orderRecordsHistory: "Recharge Order Records History",
    orderNotifyHistory: "Recharge Order Notify History",
    refundOrderHistory: "Refund Order Records History",
    smsManagement: "SMS Management",
    smsTemplateManagement: "Template Management",
    smsSendBox: "Send Box",
    smsSendRecord: "Send Record",
    smsReturnRecord: "Return Record",
    smsWaitingApproval: "Waiting Approval",
    smsManualApproval: "Manual Approval",
    smsScheduledMsg: "Scheduled Message",
    smsBlacklist: "Blacklisted Mobile",
    smsSensitiveWords: "SensitiveWords",
    smsSendBoxSubmitByForm: "Submit By Form",
    smsSendBoxSubmitByTable: "Submit By Excel",
    smsSendBoxBatchSubmitByForm: "Submit By Form (Dynamic content)",
    smsSendBoxSubmitByTemplate: "Submit By Template",
    sendCreateTimeList: "Send Create Time List",
    smsChannelGroup: "Channel Group Management",
    payChannelGroup: "Channel Group Management",
    smsChannelGroupChannel: "Channel Group's Channel Management",
    smsChannelGroupMember: "Channel Group's Member Management",
    smsChannelGroupCost: "Channel Group's Cost Management",
    payChannelGroupCost: "Channel Group's Cost Management",
    payChannelGroupCostMember: "Channel Group's Cost Member Management",
    channelManagement: "Channel Management",
    groupManagement: "Group Management",
    groupMember: "Group Member",
    channelNumberPoolLog: "Number Pool Log",
    smsChannel: "SMS Channel",
    smsChannelCost: "SMS Channel Cost",
    payChannel: "Pay Channel",
    payChannelCost: "Pay Channel Cost",
    currencyExchangeRate: "Currency Exchange Rate",
    historyRecord: "History Record",
    historySendBox: "History Send Box",
    historySentRecord: "History Sent Record",
    historyReturnedRecord: "History Return Record",
    historySendBoxSearch: "History Send Box (Search)",
    historySentRecordSearch: "History Sent Record (Search)",
    historyReturnedRecordSearch: "History Return Record (Search)",
    monitorSystem: "System Monitoring",
    monitorDaily: "System Daily Log",
    monitorLogin: "Login Log",
    scheduledTaskTitle: "Scheduled Task",
    scheduledTask: "Scheduled Task",
    scheduledTaskLog: "Scheduled Task Log",
    scheduledSMS: "Scheduled SMS",
    scheduledSMSLog: "Scheduled SMS Log",
    agentSmsManagement: 'SMS Management(Agent)',
    agentSmsSendBox: "Send Box(Agent)",
    agentSmsSendRecord: "Send Record(Agent)",
    agentHistorySendBox: "History Send Box(Agent)",
    agentHistorySendRecord: "History Sent Record(Agent)",
    orderList: "Order List",
    withdrawList: "Withdrawal List",
    grabOrder: "Grab List",
    dashboard: "Dashboard",
    documentation: "Documentation",
    guide: "Guide",
    systemConfig: "System Configuration",
    config: "Configuration",
    checkData: "Data Checks",
    dataQuery: "Check Data",
    smsQueryAnalysis: "Check SMS",
    checkPhone: "Check Phone",
    randomFailureNumber: "Check Failure Number",
    pastComprehensiveAnalysis: "Past Data Analysis",
    comprehensiveDataAnalysis: "Data Analysis",
    companyReport: "Company Report",
    companyDailyReport: "Company Daily Report",
    companyMonthlyReport: "Company Monthly Report",
    realTimeComprehensiveAnalysis: "Present Data Analysis",
    receiptNumberAnalysis: "Notify Number Analysis",
    areaReportAnalysis: "Area Report Analysis",
    channelInformationList: "Channel Information",
    quartzConfig: "Scheduling Config",
    channelRateAnalysis: "Channel Rate Analysis",
    enterpriseRateAnalysis: "Enterprise Rate Analysis",
    hourlyDataReportAnalysis: "Hourly Report Analysis",
    accountManagement: "Account Management",
    accountView: "Account Management",
    roleManagement: "Role Management",
    permission: "Permission",
    rolePermission: "Role Permission",
    pagePermission: "Page Permission",
    directivePermission: "Directive Permission",
    icons: "Icons",
    components: "Components",
    tinymce: "Tinymce",
    markdown: "Markdown",
    jsonEditor: "JSON Editor",
    dndList: "Dnd List",
    splitPane: "SplitPane",
    avatarUpload: "Avatar Upload",
    dropzone: "Dropzone",
    sticky: "Sticky",
    countTo: "Count To",
    componentMixin: "Mixin",
    backToTop: "Back To Top",
    dragDialog: "Drag Dialog",
    dragSelect: "Drag Select",
    dragKanban: "Drag Kanban",
    charts: "Charts",
    keyboardChart: "Keyboard Chart",
    lineChart: "Line Chart",
    mixChart: "Mix Chart",
    example: "Example",
    nested: "Nested Routes",
    menu1: "Menu 1",
    "menu1-1": "Menu 1-1",
    "menu1-2": "Menu 1-2",
    "menu1-2-1": "Menu 1-2-1",
    "menu1-2-2": "Menu 1-2-2",
    "menu1-3": "Menu 1-3",
    menu2: "Menu 2",
    Order: "order",
    Table: "Table",
    dynamicTable: "Dynamic Table",
    dragTable: "Drag Table",
    inlineEditTable: "Inline Edit",
    complexTable: "Complex Table",
    tab: "Tab",
    form: "Form",
    createArticle: "Create Article",
    editArticle: "Edit Article",
    articleList: "Article List",
    errorPages: "Error Pages",
    page401: "401",
    page404: "404",
    errorLog: "Error Log",
    excel: "Excel",
    exportExcel: "Export Excel",
    selectExcel: "Export Selected",
    mergeHeader: "Merge Header",
    uploadExcel: "Upload Excel",
    zip: "Zip",
    pdf: "PDF",
    exportZip: "Export Zip",
    theme: "Theme",
    clipboardDemo: "Clipboard",
    i18n: "I18n",
    externalLink: "External Link",
    profile: "Profile"
  },
  navbar: {
    dashboard: "Dashboard",
    github: "Github",
    logOut: "Log Out",
    profile: "Profile",
    theme: "Theme",
    size: "Global Size",
    enterFullScreen: 'Enter Full Screen',
    exitFullScreen: 'Exit Full Screen',
    switchLanguage: 'Switch Language',
    refreshCache: 'Refresh Cache'
  },
  login: {
    capslockOn: 'Caps lock is On',
    emailError: "Please enter the correct user name",
    passwordError: "The password can not be less than 6 digits",
    title: "Login Form",
    titleAdmin: "Admin Login System",
    titleAgent: "Agent Login System",
    titleMerchant: "Merchant Login System",
    logIn: "Login",
    username: "Username",
    password: "Password",
    any: "Any",
    thirdparty: "Or connect with",
    thirdpartyTips: "Can not be simulated on local, so please combine you own business simulation! ! !",
    authenticator: "Google Authenticator Code",
    rememberMe: "Remember Me"
  },
  documentation: {
    documentation: "Documentation",
    github: "Github Repository"
  },
  permission: {
    addRole: "New Role",
    editPermission: "Edit",
    roles: "Your roles",
    switchRoles: "Switch roles",
    tips: "In some cases, using v-permission will have no effect. For example: Element-UI  el-tab or el-table-column and other scenes that dynamically render dom. You can only do this with v-if.",
    delete: "Delete",
    confirm: "Confirm",
    cancel: "Cancel"
  },
  guide: {
    description: "The guide page is useful for some people who entered the project for the first time. You can briefly introduce the features of the project. Demo is based on ",
    button: "Show Guide"
  },
  components: {
    documentation: "Documentation",
    tinymceTips: "Rich text is a core feature of the management backend, but at the same time it is a place with lots of pits. In the process of selecting rich texts, I also took a lot of detours. The common rich texts on the market have been basically used, and I finally chose Tinymce. See the more detailed rich text comparison and introduction.",
    dropzoneTips: "Because my business has special needs, and has to upload images to qiniu, so instead of a third party, I chose encapsulate it by myself. It is very simple, you can see the detail code in @/components/Dropzone.",
    stickyTips: "when the page is scrolled to the preset position will be sticky on the top.",
    backToTopTips1: "When the page is scrolled to the specified position, the Back to Top button appears in the lower right corner",
    backToTopTips2: "You can customize the customCSS of the button, show / hide, height of appearance, height of the return. If you need a text prompt, you can use element-ui el-tooltip elements externally",
    imageUploadTips: "Since I was using only the vue@1 version, and it is not compatible with mockjs at the moment, I modified it myself, and if you are going to use it, it is better to use official version."
  },
  partner: {
    dynamicTips1: "Fixed header, sorted in order of header",
    dynamicTips2: "Unfixed header, sort by click order",
    dragTips1: "Default order",
    dragTips2: "Order after drag",
    name: "name",
    rate: "cost rate",
    money: "Amount",
    search: "search",
    add: "add",
    amount: "balance",
    rechangeAmount: "Total recharge amount",
    customeAmount: "Total consumption amount",
    freeze: "Frozen amount",
    export: "export",
    reviewer: "Reviewer",
    id: "Serial id",
    date: "Update time",
    author: "author",
    readings: "reading number",
    status: "status",
    actions: "actions",
    edit: "edit",
    publish: "publish",
    draft: "draft",
    delete: "delete",
    cancel: "cancel",
    confirm: "confirm",
    phone: "phone",
    email: "email",
    account: "login account",
    pwd: "password",
    againPwd: "enter again",
    merchantName: "merchant name",
    merchantId: "merchant id",
    currentAmount: "current amount",
    opAmount: "change amount",
    odAmount: "changed amount",
    actualAmount: "actual amount",
    type: "type",
    partner: "access ID",
    openApiAccountName: "receiver name",
    orderNo: "order no"
  },
  order: {
    dynamicTips1: "Fixed header, sorted by header order",
    dynamicTips2: "Not fixed header, sorted by click order",
    dragTips1: "The default order",
    dragTips2: "The after dragging order",
    name: "Name",
    rate: "Cost rate",
    money: "Amount",
    search: "Search",
    add: "Add",
    amount: "Balance",
    rechangeAmount: "Recharge amount",
    customeAmount: "Total consumption amount",
    freeze: "Frozen amount",
    export: "Export",
    reviewer: "Reviewer",
    id: "ID",
    date: "Date",
    author: "Author",
    readings: "Readings",
    status: "Status",
    actions: "Actions",
    edit: "Edit",
    publish: "Publish",
    draft: "Draft",
    delete: "Delete",
    cancel: "Cancel",
    confirm: "Confirm",
    create_time: "Create time",
    finish_time: "Complete time",
    update_time: "Update time",
    pdd_confirm_time: "Confirm receipt time",
    pdd_send_time: "Delivery time",
    open_api_account_kid: "Partner id",
    order_no: "Order number",
    user_order_no: "Third-party order number",
    order_mobile: "Order number",
    pay_url: "Payment address",
    pdd_status: "Receipt status",
    review_time: "Review time",
    partner_info: "Cooperative merchant information",
    partner_kid: "Cooperative merchant id",
    partner_name: "Cooperative merchant name",
    review_user_info: "Reviewer information",
    review_user_kid: "Reviewer id",
    review_user_name: "Reviewer name",
    bank_address: "Bank information",
    card: "Bank card number",
    withdraw_info: "Withdraw person information",
    agent_kid: "Agent id",
    merchant_kid: "Partner merchant id",
    review_account_kid: "Reviewerid",
    start_create_time: "Create start time",
    end_create_time: "End start time",
    agent_info: "Agency related",
    certificate_url: "Voucher photo",
    msgId: "Message ID",
    resMsg: "Notify Message",
    notifyTime: "Notify Time",
    notifyProperty: "Notify Property"
  },
  table: {
    dynamicTips1: "Fixed header, sorted by header order",
    dynamicTips2: "Not fixed header, sorted by click order",
    dragTips1: "The default order",
    dragTips2: "The after dragging order",
    title: "Title",
    importance: "Imp",
    type: "Type",
    remark: "Remark",
    search: "Search",
    add: "Add",
    export: "Export",
    reviewer: "reviewer",
    id: "ID",
    date: "Date",
    author: "Author",
    readings: "Readings",
    status: "Status",
    actions: "Actions",
    edit: "Edit",
    publish: "Publish",
    draft: "Draft",
    delete: "Delete",
    cancel: "Cancel",
    confirm: "Confirm"
  },
  example: {
    warning: "Creating and editing pages cannot be cached by keep-alive because keep-alive include does not currently support caching based on routes, so it is currently cached based on component name. If you want to achieve a similar caching effect, you can use a browser caching scheme such as localStorage. Or do not use keep-alive include to cache all pages directly. See details"
  },
  errorLog: {
    tips: "Please click the bug icon in the upper right corner",
    description: "Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.",
    documentation: "Document introduction"
  },
  excel: {
    export: "Export",
    selectedExport: "Export Selected Items",
    placeholder: "Please enter the file name (default excel-list)"
  },
  zip: {
    export: "Export",
    placeholder: "Please enter the file name (default file)"
  },
  pdf: {
    tips: "Here we use window.print() to implement the feature of downloading PDF."
  },
  theme: {
    change: "Change Theme",
    documentation: "Theme documentation",
    tips: "Tips: It is different from the theme-pick on the navbar is two different skinning methods, each with different application scenarios. Refer to the documentation for details."
  },
  tagsView: {
    refresh: "Refresh",
    close: "Close",
    closeOthers: "Close Others",
    closeAll: "Close All"
  },
  settings: {
    title: "Page customCSS setting",
    theme: "Theme Color",
    tagsView: "Open Tags-View",
    fixedHeader: "Fixed Header",
    sidebarLogo: "Sidebar Logo"
  },
  SMS: {
    msgIdText: 'Merchant Order Number',
    superiorAgentIncome: 'Superior Agent Income',
    AutomaticConfiguration: 'Automatic configuration',
    remark: "Remarks",
    verificationCode: "Verification code",
    rechargeAmount: "Recharge amount",
    increaseAmount: 'Increase Amount',
    convertedAmount: 'Converted Amount',
    exchangeRate: 'Rate',
    moneyTypeFrom: 'Original currency',
    moneyTypeTo: 'Target currency',
    moneyTypeToReport: 'Payment Currency',
    rechargeMethod: "Recharge Method",
    agentId: "Agent",
    agentNameText: "Agent",
    organizationName: "Organization Name",
    salesman: "Salesperson",
    status: "Status",
    approveState: "Approve State",
    checkNumberCountState: "Number Count State",
    username: "Username",
    organizationCode: "Organization Code",
    loginAccount: "Login Account",
    fullName: "Name",
    totalRechargeYuan: "Total Recharge",
    amountAvailableYuan: "Available Amount",
    consumptionAmountYuan: "Consumption Amount",
    frozenAmount: 'Frozen Amount',
    uncreditedAmount: 'Uncredited Amount',
    numberOfSent: "Amount of Sent",
    smppConnectionStatus: "SMPP Connection Status",
    smsApproveType: "SMS Approve Type",
    createTime: "Create Time",
    operating: "Operating",
    interfaceType: "Interface Type",
    delayedSettlement: "Delayed Settlement",
    bindIP: "Bind IP",
    smsSignature: "SMS Signature",
    corporateWebsite: "Organization Website",
    companyAddress: "Organization Address",
    enterpriseMailbox: "Organization Mailbox",
    contactNumber: "Phone",
    contactPerson: "Contact Person",
    confirmPassword: "Confirm Password",
    password: "Password",
    alarm: "Alarm",
    success: "Success",
    accountType: "Account Type",
    lastLoginIPAddress: "Last Login IP Address",
    lastLoginTime: "Last Login Time",
    pleaseSelectUserType: "Please select user type",
    balanceProcessing: "Balance Processing",
    tariffName: "Tariff Name",
    tariff: "Cost",
    smsType: "SMS Type",
    areaCode: "Area Code",
    channel: "Channel",
    operationUser: "Operation User",
    operationContent: "Operation Content",
    operationMethod: "Operation Method",
    timeConsuming: "Time Consuming",
    methodParameters: "Method Parameters",
    methodResponse: 'Method Response',
    ipAddress: "IP Address",
    operatingLocation: "Operating Location",
    canNotBeEmpty: " can not be empty",
    contactMobile: "Contact number",
    workingFor: "Working for",
    description: "Description",
    name: "Name",
    accountCannotBeEmpty: "Account cannot be empty",
    rolePermissions: "Role Permissions",
    updateRolePermissions: "Update Role Permissions",
    parentId: "Parent ID",
    type: "Type",
    icon: "Icon",
    permission: "Permission",
    sequence: "Sequence",
    createNewUser: "Add New User",
    editUser: "Edit User",
    create: "Create",
    update: "Update",
    viewUser: "View Users",
    levelCode: "Level",
    systemName: "Platform Name",
    smsDomainAddress: "Domain Address",
    platformLOGO: "Platform LOGO",
    platformBackgroundImage: "Platform Background Wallpaper",
    upAgentId: "Superior agent",
    amountOfProfit: "Amount of Profit",
    userStatus: "User Status",
    numberOfFailedLogins: "Number of Failed Logins",
    agentName: "Name",
    agentAccount: "Username",
    payPassword: "Payment Password",
    phoneNumber: "phone number",
    email: "Mailbox",
    changeAmount: "Maximum Conversion Amount",
    bingQrcode: "Bind Google Code",
    unboundVerificationCode: "Unbound Verification Code",
    manipulator: "Manipulator",
    profitBeforeOperation: "Profit Before Operation",
    profitAfterOperation: "Profit After Operation",
    operationAmount: "Operation Amount",
    amountAvailableAfterOperation: "Amount Available After Operation",
    submissionTime: "Submission Time",
    orderNumber: "Order Number",
    rechargeType: "Recharge Type",
    netwayCode: "Recharge Method",
    reqStateCode: "Request State",
    rechargeStateCode: "Recharge State",
    createUser: "Create User",
    rechargeCompleteTime: "Recharge Completion Time",
    founder: "Founder",
    payChannelId: "Channel",
    payMerchNo: "Channel Merchant Number",
    rechargeCompletionTime: "Recharge Completion Time",
    requestStatusDescription: "Request State Description",
    agentRemitOrder: "Agent Remit order",
    organizationRemitOrder: "Organization Remit order",
    remitType: "Remit Type",
    withdrawalAmount: "Withdrawal Amount",
    approvalStatus: "Approval Status",
    bankName: "Bank Name",
    bankCardNumber: "Bank Card Number",
    branchName: "Branch Name",
    transferVoucher: "Transfer Voucher",
    rejectReason: 'Reject reason',
    availableProfit: "Available Profit",
    availableProfitBefore: 'Available Profit Before Withdrawal',
    examinationPassed: "Approved",
    accountName: "Account Name",
    statisticsDate: "Statistics Date",
    export: "Export",
    total: "Total",
    totalNumberOfOutbox: "Total Number of Outboxes",
    billingNumberOfOutbox: "Billing number of outbox",
    sortingFailed: "Sorting Failed",
    toBeSent: "Waiting to Submit",
    submittedSuccessfully: "Submitted Successfully",
    submissionFailed: "Submission Failed",
    successfullyReceived: "Received Successfully",
    receiveFailed: "Receive failed",
    successRate: "Success Rate",
    amountOfConsumption: "Consumption Amount",
    amountPerSMSCount: 'Consumption Amount per each SMS',
    costValue: 'Cost Value',
    agencyProfit: "Agency Profit",
    upAgencyProfit: 'Superior Agency Income',
    channelCost: "Channel Cost",
    profit: "Profit",
    date: "Date",
    enterpriseMonthlyReport: "Organization Monthly Report",
    channelName: "Channel Name",
    tiao: " Item",
    yuan: " Dollar",
    totalText: "Total",
    platformProfit: "Platform Profit",
    corporateDailyReport: "Organization Daily Report",
    statistic: "View statistics",
    batchNumber: "Batch Number",
    operator: "Operator",
    totalDailyReport: "Total Daily Report",
    statistics: "Statistics",
    agentMonthlyReport: "Agent Monthly Report",
    sixMonthData: "The first 1000 of the total data in 6 months",
    sixMonthDataForApi: "Total Query Times in 6 months",
    sixDayData: "Total data in 6 days",
    sixDayDataForApi: 'Total Query Times in 6 days',
    numberPool: "Number Pool",
    usageCount: "Number of usage",
    useNumberPool: "Use number pool",
    oldPassword: "Original Password",
    newPassword: "New Password",
    oldPayPassword: "Original Payment Password",
    newPayPassword: "New Payment Password",
    confirmPayPassword: "Confirm Payment Password",
    loginFailedCount: 'Number of failed logins',
    conversionAmount: 'Conversion Amount',
    withdraw: 'Withdraw',
    remitAmount: 'Available Amount',
    dollar: 'Dollar',
    channelMonthlyReport: 'Channel Monthly Report',
    loginPassword: 'Login Password',
    newLoginPassword: 'New Login Password',
    smsContent: 'Message Content',
    pleaseEnterText: 'Please Enter',
    pleaseChoose: 'Please Choose',
    googleQrCode: 'Google QR code',
    forceLogoffText: "Force Logoff",
    removeGoogle: "Clear Google",
    bankCode: 'Bank Name',
    bankBranch: 'Bank Branch Name',
    bankAccountName: 'Bank Account Name',
    bankAccountNo: 'Bank Account ID',
    availableAmount: 'Available Amount',
    error: 'Error',
    googleVerifyCode: 'Google Verification Code',
    lastUseTime: 'Last Used Time',
    forceBindGoogleText: "Force Bind Google Verification Code",
    activeUserText: "Active User",
    isStoredGoogleText: "Google Verification Code Status",
    notifyUrl: "Notification address",
    channelId: "Channel",
    totalSMSText: 'Total SMS',
    totalChannelText: 'Total Channel',
    totalChannelOperatorText: 'Total Channel Operator',
    totalAgentText: 'Total Agent',
    totalOrgText: 'Total Organization',
    consumeAmountDailyExcelText: "CostDailyReport.xlsx",
    consumeAmountMonthlyExcelText: "CostMonthlyReport.xlsx",
    activeUserTimeRangeText: "Active User Time Range",
    exportActiveUserReportText: "Export Active User Report",
    activeUserExcelText: "activeUserExcel.xlsx",
    weightingOrg: "Weighting",
    upNotifyTime: "ChannelNotifyTime",
    downNotifyTime: "ClientNotifyTime",
    orderCreateFailCount: "CreateFail",
    orderCreateSuccessCount: "CreateSuccess",
    channelSubmitFailCount: "SubmitFail",
    channelSubmitSuccessCount: "SubmitSuccess",
    channelNotifyFailCount: "FailNotify",
    channelNotifySuccessCount: "SuccessNotify",
    refundCount: 'Refund',
    depositedCount: 'Deposited'
  },
  organizationUserSettings: {
    excelFormatText: "Excel Format",
    rowLimitText: "Row Maximum Limit"
  },
  option: {
    manual: 'Manual',
    automatic: 'Automatic',
    pending: "Pending",
    examinationPassed: "Approve",
    auditNotPassed: "Reject",
    platformRecharge: "Platform Recharge",
    agentRecharge: "Agent Recharge",
    transactionRecharge: "Transaction Recharge",
    success: "Success",
    failure: "Failure",
    signatureError: "Signature Error",
    otherErrors: "Other Errors",
    unpaid: "Unpaid",
    initial: "Initial",
    menu: "Menu",
    button: "Button",
    mainAccount: "Main Account",
    subAccount: "Subaccount",
    pleaseChoose: "Please Choose",
    templateExemption: "Template Exemption",
    templateSendOnly: 'Send Template Only',
    manualReview: "Manual Review",
    exemption: "Exemption",
    doNotUse: "Do Not Use",
    use: "Use",
    regular: "Regular",
    locking: "Locking",
    invalid: "Invalid",
    notApproved: "Not Approved",
    approved: "Approved",
    rejected: "Rejected",
    donTDealWith: "Do Not Process",
    transferToProcessing: "Transfer To Processing",
    alipay: "Alipay",
    alipayHK: 'Alipay Hong Kong',
    alipayApp: "Alipay App",
    alipayAppHK: 'Alipay App Hong Kong',
    wechat: "WeChat",
    wechatHK: 'WeChat Hong Kong',
    wechatH5: "WeChat H5",
    wechatH5HK: 'WeChat H5 Hong Kong',
    wechatApp: "WeChat App",
    wechatAppHK: 'WeChat App Hong Kong',
    weChatPayMiniProgram: 'WeChat Mini Program',
    AlipayMiniProgramHK: 'Alipay Mini Program HK',
    AlipayMiniProgramCN: 'Alipay Mini Program CN',
    ApplePayCNTest: 'Apple Pay Test',
    GooglePayTest: 'Google Pay Test',
    SecureAcceptanceTest: 'Secure Acceptance Test',
    wechatAppByWeChat: 'WeChat App(WeChat Owned)',
    paypalHK: 'PayPal Hong Kong',
    paypalUS: 'PayPal US',
    applePay: 'Apple Pay',
    applePayCN: 'Apple Pay China',
    googlePay: 'Google Pay',
    secureAcceptance: 'Secure Acceptance',
    cyberSource: 'CyberSource',
    onlineBanking: "Online Banking",
    enterpriseAbolishedAndTransferredIn: "Organization abolished and transferred in",
    sms: "SMS",
    domestic: "Domestic",
    hongKong: "Hong Kong",
    normal: "normal",
    malaysia: "Malaysia",
    chinaHongKong: "China Hong Kong",
    deleteTariff: "Delete Cost",
    smsContent: 'SMS Content',
    cancel: "Cancel",
    CTCC: "China Telecom",
    CMCC: "China Mobile",
    CUCC: "China Unicom",
    unknownChannelOperator: "Unknown Channel Operator",
    SMS: "SMS",
    PSBC: "China Postal Savings Bank",
    SPDB: "Shanghai Pudong Development Bank",
    CNCB: "China CITIC Bank",
    CIB: "Industrial Bank",
    HXB: "HUA XIA BANK",
    CMBC: "China Minsheng Bank",
    CEB: "China Everbright Bank",
    CMB: "China Merchants Bank",
    BCM: "Bank of Communications",
    CCB: "China Construction Bank",
    ICBC: "Industrial and Commercial Bank of China Limited",
    ABC: "Agricultural Bank of China Limited",
    BOC: "Bank of China Limited"
  },
  message: {
    h: 'h',
    m: 'm',
    s: 's',
    timeDiff: 'Receipt Interval Time',
    titletable: 'Submit By Table',
    title: 'Submit By Form',
    submitByTemplateTitle: 'Submit By Template',
    message1: "Data will be deleted. Continue?",
    permissionMessage1: "The record will be deleted. If the record contains sub-records, it will also be deleted. Continue?",
    organizationManagementMessage2: "Approve has been cancelled",
    message3: "Deletion has been cancelled",
    organizationManagementMessage4: "Delete successfully!",
    message5: "Deletion unsuccessful!",
    message6: "Added successfully",
    organizationManagementMessage7: "Suspended successfully",
    organizationManagementMessage8: "Suspended unsuccessful",
    message9: "Approved successfully",
    message10: "Approved unsuccessful",
    message11: "Rejected successfully",
    message12: "Rejected unsuccessful",
    organizationManagementMessage13: "The password length should be between 8 and 20",
    organizationManagementMessage14: "The password and confirm password are inconsistent",
    organizationManagementMessage15: "The user name should be 6 and 15",
    message16: "Please select at least one data for operation! (Check the box on the leftmost side of the data)",
    organizationManagementMessage17: "Invalid phone number, currently only supports mainland calls",
    message18: "Recharge successful",
    organizationManagementMessage19: "Invalid successfully",
    organizationManagementMessage20: "The cost has been added successfully",
    organizationManagementMessage21: "Cost update successfully",
    message21: "Change the approve status to approve. Continue?",
    message22: "Change the approve status to reject. Continue?",
    message23: "Reject has been cancelled!",
    organizationManagementMessage24: "Invalided unsuccessful!",
    message25: "Approve has been cancelled!",
    message26: "Recharge unsuccessful!",
    organizationManagementMessage27: "Data will be locked. Continue?",
    organizationManagementMessage28: "Locked successfully!",
    organizationManagementMessage29: "Locked unsuccessful!",
    organizationManagementMessage30: "Data will be unlocked. Continue?",
    organizationManagementMessage31: "Locked data has been cancelled.",
    organizationManagementMessage32: "Unlocking data has been cancelled.",
    organizationManagementMessage33: "Unlocked successfully.",
    organizationManagementMessage34: "Unlocked unsuccessful.",
    message35: "Password will be reset. Continue?",
    message36: "Reset password has been cancelled!",
    message37: "Password reset successfully!",
    message38: "Failed to reset password!",
    Message39: "Please select a menu",
    message40: "Adding failed",
    message41: "Edited successfully",
    message42: "Edited unsuccessful",
    organizationManagementMessage43: "Update role permissions succeeded",
    organizationManagementMessage44: "Failed to update role permissions",
    message45: "Data has not been modified in any way",
    message46: "Change the approve status to approved. Continue?",
    message47: "Change the approve status to reject. Continue?",
    message48: "The audit failed and has been cancelled!",
    message49: "Approval has been cancelled!",
    message50: "Approved successfully!",
    message51: "Approved unsuccessfully!",
    message52: "Rejected successfully!",
    message53: "Rejected unsuccessfully!",
    message54: "Please select the transfer voucher",
    batchNumberText: "Batch Number",
    phoneNumberText: 'Phone Number',
    operatorText: 'Operator',
    organizationNameText: 'Organization',
    subordinateAgentNameText: "Subordinate Agent",
    organizationIDText: 'ID',
    smsContentText: 'Information Content',
    informationTypeText: 'Information Type',
    auditStatusText: 'Audit State',
    submitMethodText: 'Submit Method',
    messagesDetailText: 'Messages Detail',
    submitTimeText: 'Submit Time',
    submitterText: 'Submitter',
    createTimeText: 'Create Time',
    amountDetailText: 'Amount Detail',
    updateOrganizationInformationText: 'Update Information',
    toText: 'To',
    receiveStatusText: 'Receive Status',
    requestStatusText: 'Request Status',
    channelText: "Channel",
    statusText: 'Status',
    resubmitText: 'Resubmit',
    totalCustomersText: 'Total Customers',
    customerUnitText: 'Customers',
    totalRecord: 'Total Record',
    recordUnitText: 'Record',
    smsCountMessageText: 'SMS Count',
    consumeAmountText: 'Consume Amount',
    consumeAmountWithUnitText: "Consumption amount",
    channelCostText: 'Channel Cost',
    dollarUnitText: 'Dollar',
    subordinateAgentIncomeText: "Subordinate Agent Income",
    agentRewardText: 'Agent Income',
    agentReward2Text: 'Income',
    agentRewardWithUnitText: 'Income',
    validSMSMessageText: "Valid SMS Message",
    platformRewardText: 'Platform Reward',
    todayMaximumSpeedText: 'Today Maximum Speed',
    currentSpeedText: 'Current Speed',
    expectedCompleteTimeText: 'Expected Complete Time',
    channelOperatorText: 'Phone Operator',
    channelOperatorDetailText: 'Phone Operator Detail',
    selectBatchMessageResubmitText: 'Resubmit Batch Message',
    selectBatchMessageResubmitNoticeText: 'Resubmit Batch Message Notice',
    selectBatchMessageConditionalResubmitText: 'Conditional Resubmit Batch Message',
    selectBatchMessageConditionalResubmitNoticeText: 'Conditional Resubmit Batch Message Notice',
    selectBatchMessageConditionalUpdateReturnSuccessText: "Conditional Force Return Success",
    selectBatchMessageConditionalUpdateReturnFailText: "Conditional Force Return Fail",
    exportMSGIDText: "Export MSGID",
    exportUpstreamSortingFailText: "Export Sorting Fail Report",
    returnTimeText: 'Return Time',
    channelMessageLogoText: 'Channel Msg Logo',
    phoneNumberCount: 'Total Phone Numbers',
    auditApproveText: 'Audit Approve',
    auditRefuseText: 'Audit Refuse',
    manualSubmitText: "Manual Submit",
    manualCancelText: "Manual Cancel",
    agentIDText: 'Agent ID',
    countryCallingCodesText: 'Country Calling Code',
    phoneNumberSetText: 'Phone number set (Separate by comma)',
    phoneNumberCountText: 'Phone Number Count',
    validMessageNumberText: 'Valid Message Number',
    messageWordCountText: 'Word Count',
    rejectReasonText: 'Reject reason',
    clientIPAddressText: 'Client IP',
    scheduledTimeText: 'Scheduled Time',
    sortingTimeText: 'Sorting Time',
    agentRevenueText: 'Agent Revenue',
    platformRevenueText: 'Platform Revenue',
    regionText: 'Region',
    operationText: 'Operation',
    addInformationText: 'Add Information',
    addChannelText: "Add Channel",
    createSimilarChannelText: "Create Similar Channels",
    updateChannelText: "Update Channel",
    addPayChannelText: "Add Pay Channel",
    updatePayChannelText: "Update Pay Channel",
    addTemplateText: "Add Template",
    updateTemplateText: "Update Template",
    numberRegionText: 'Number Region',
    addSensitiveWordText: 'Add Sensitive Word',
    sensitiveWordText: 'Sensitive Word',
    sensitiveWordDocumentText: 'Sensitive Word Document',
    supportFormatMessage: "(Support Document Format : txt)",
    templateNameText: "Template Name",
    templateVariableText: "Variable Content",
    templateVariableLocationText: "Variable Content Location",
    templateVariableRemarkText: "Variable Content Remark",
    templateVariableRemarkMessage: "[] will be the location of variable content. The SMS content must contain all non-variable contents with same location and same characters which include spaces and punctuations.",
    templateVariableExampleText: "Variable Content Example",
    templateVariableExampleMessage1: "Example:Authentication Code Template#Your Authentication Code:[0]. Expire in [1] minute(s)!",
    templateVariableExampleMessage2: "Possible SMS Content:Authentication Code Template#Your Authentication Code:123456. Expire in 5 minute(s)!",
    templateContentText: "Template Content",
    descriptionText: "Description",
    updateInformationText: "Update Information",
    totalText: "Total",
    submitSuccessText: "Submit success",
    submitFailText: "Submit fail",
    receiveSuccessText: "Receive success",
    receiveFailText: "Receive fail",
    receiveUnknownText: "Receive unknown",
    sortingFailText: "Sorting fail",
    waitingSubmitText: "Waiting submit",
    successRateText: "Success rate",
    mobileSuccessRateText: "Mobile Success Rate",
    sendBoxExcelText: "sendBoxExcel.xlsx",
    sendBoxHistoryExcelText: "historySendBoxExcel.xlsx",
    sendRecordExcelText: "sendRecordExcel.xlsx",
    sendRecordHistoryExcelText: "historySendRecordExcel.xlsx",
    returnRecordExcelText: "returnRecordExcel.xlsx",
    returnRecordHistoryExcelText: "historyReturnRecordExcel.xlsx",
    message55: "Login has expired, please log in again",
    message56: "Sorry, you don't have the right to operate",
    message57: "Password modified successfully",
    message58: "Please fill in the correct domain name",
    message59: "Add system configuration successfully",
    message60: "Drag the file here, or",
    message61: "click to upload",
    message62: "Only upload jpg/png files, and no more than 500kb",
    message63: "Reminder: Please enter the Google code and payment password after the mobile phone scans the code, the Google binding is completed after submission! ",
    submitDetailText: "Submit Detail",
    returnDetailText: "Return Detail",
    numberDocumentText: "Number Document",
    dynamicVariableDocumentText: "Dynamic Variable Document",
    splitNumberText: 'SMS Numbers Per Batch',
    remarkSplitNumberMessage: 'SMS numbers will be split by "SMS Numbers Per Batch" to replace variable in SMS content with value written in dynamic variable document.If the value of "SMS Numbers Per Batch" is 500, variable in SMS content will be changed every 500 SMS numbers until all SMS numbers are processed',
    remarkSplitNumberLimitMessage: 'The minimum value of "SMS Numbers Per Batch" MUST be 500 or multiple of 500',
    remarkDynamicVariableInContentMessage: "##A## is the location for dynamic variables. If content is not contain not ##A##, this submission will be fail.",
    remarkDynamicVariableInContentExampleMessage: "If the content is 'Hello, ##A##' and variable is 'World',then the actual content to be delivered will be 'Hello, World'.",
    smsMessageContentText: "SMS Message Content",
    smsMessageTemplateContentText: "SMS Message Template Content",
    wordCountText: "Word Count",
    scheduledSubmitText: "Scheduled Submit",
    remarkText: "Remark",
    remarkEnterNumberMessage: "Please separate each phone number by comma or by new line for more than one phone number. MAXIMUM inputs are 50,000. Support document format : TXT",
    remarkSMSNumberLimitMessage: "The minimum SMS number is 500 for dynamic content submit",
    remarkNumberDocumentMessage: "Each document allows maximum 50000 phone numbers which separated by comma or by new line. Support document format : TXT",
    remarkDynamicVariableDocumentMessage: "(Number of item in dynamic variable document should be same as number of batch after splitting, If they are not the same, this submission will be fail. Support document format : TXT)",
    remarkScheduledSendMessage: "(By default send sms message immediately.)",
    remarkIsStoredScheduledTimeMessage: "(By default clear scheduled time after submit sms message.)",
    clearScheduledTimeMessage: "Clear scheduled time",
    notClearScheduledTimeMessage: "Not clear scheduled time",
    totalWordCountText: "characters",
    separateText: "are separated as",
    totalMessageText: "messages",
    remarkReminderMessage: "For message which includes signature with characters are less than 70, it will be charged as 70 characters per each message. If characters are more than 70, it will be charged as 67 characters per each message. Total characters of each message MUST not more than 500 characters.",
    tableRemarkNumberDocumentMessage1: "The first column is read as title by default and it will not be imported. The content of the first column MUST be phone number.",
    tableRemarkNumberDocumentMessage2: "Document size MUST not larger than 2MB. Support document formats : Excel2003(xls),Excel2007(xlsx)",
    tableRemarkNumberDocumentMessage3: "Click HERE to view the example of how to submit the form.",
    numberDocumentListText: "Column",
    exampleText: "Example",
    viewSMSNumbersText: "View SMS Numbers",
    viewStatusDescText: "Channel Request Return Information",
    downloadSMSNumbersText: "Download SMS Numbers",
    message64: "Reset the password to ",
    message65: "Reset the password to (1234Qwer)!",
    importTemplateText: "Template Import",
    importTemplateRemark1Message: "Remark: Every template occupies one row only. For more than one templates, please wrap to next row.",
    importTemplateRemark2Message: "Data format on every line: Template Name + # + Template Content",
    importTemplateRemark3Message: "Example: Verification Code Template#Your verification code:{0}, Please do not show the code to other. The code will be expired {1} minutes.",
    importTemplateRemark4Message: "Support Document Format: txt",
    selectDocumentText: "Select Document",
    sendBoxCreateTime: "Send Box Create Time",
    sendRecordCreateTime: "Send Record Create Time",
    message66: 'Bind Google Code',
    cancelScheduleText: "Cancel Schedule",
    message67: 'Successful conversion',
    message68: 'Withdrawal review',
    message69: 'The transfer voucher cannot be empty',
    message70: 'Use password pool successfully',
    message71: 'Payment password changed successfully',
    message72: 'Username length need to be between 6 and 20',
    message73: 'The length of the payment password is from 8 to 20',
    message74: 'The user name cannot be Chinese (including Chinese symbols)',
    message75: 'The mailbox cannot be in Chinese (including Chinese symbols)',
    message76: 'Username length need to be between 6 and 20',
    message77: "Tip: After scanning the code on your mobile phone, please enter the Google code and login password, " + "and the submission is successful to complete the Google binding!",
    provinceNameText: "Province",
    countryNameText: "Country",
    internationalChannelOperatorNameText: "International Channel Operator",
    submitMessageText: "Submit Messages",
    cancelMessageText: "Cancel Schedule",
    submitByFormText: "Submit By Form",
    submitByExcelText: "Submit By Table",
    submitByTemplateText: "Submit By Template",
    noUseNumberReportText: "Export No Use Number",
    sendBoxNoUseNumberExcelText: "SendBoxNoUseNumber.xlsx",
    errorUnauthorized: "Authorization Error: Please refresh your page to reestablish connection. If tried above action, please contact Administrator.",
    errorNetwork: "The network fluctuates, please resubmit or log in again to operate.",
    smsNumbersType: "Sms Numbers Type",
    pleaseSelectCostNameText: "Please Cost Name",
    pleaseSelectCountryNameText: "Please select Country",
    paySuccess: "Payment success!",
    payFailure: "Payment failure!",
    ifItDidNotRedirect: 'Please close the browser if it did not redirect to the home page.'
  },
  monitor: {
    operatorText: "Operator",
    operatorType: "Operator Type",
    operationTimeText: "Operation Time",
    operationDescriptionText: "Operation Description",
    elapsedTimeText: 'Elapsed Time',
    operationMethodText: "Operation Method",
    methodParameterText: "Method Parameter",
    IPAddressText: 'IP Address',
    operationLocationText: "Operation Location",
    createTimeText: 'Create Time',
    loginUserText: "Login User",
    loginTimeText: 'Login Time',
    operationText: 'Operation',
    loginLocationText: 'login Location',
    loginSystemText: 'Login System',
    loginBrowserText: 'Browser'
  },
  job: {
    content: "Content",
    sendCode: "Send Code",
    beanNameText: "Bean Name",
    methodNameText: "Method Name",
    statusText: "Status",
    taskIDText: "Task ID",
    methodParameterText: "Method Parameter",
    cronExpressionText: "Cron Expression",
    remarkText: "Remark",
    createTimeText: "Create Time",
    operationText: "Operation",
    abnormalInformationText: "Abnormal Information",
    elapsedTimeText: "Elapsed Time",
    executedTimeText: "Executed Time",
    updateInformationText: "Update Information",
    addJobText: "Add Job",
    updateJobText: "Update Job",
    deleteJobText: "Delete Job",
    batchDeleteJobText: "Batch Delete Job",
    pauseJobText: "Pause Job",
    resumeJobText: "Resume Job",
    runJobText: "Run Job",
    exportExcelText: "Export Excel",
    scheduledTaskExcelText: "scheduledTaskExcel.xlsx",
    jobOperationText: "Job Operation"
  },
  agent: {
    agentNameText: "Agent Name",
    agentIdText: "Agent ID",
    channelText: "Channel",
    channelNameText: "Channel Name",
    payChannelName: "Pay Channel",
    payMethod: "Payment Method",
    costNameText: "Cost Name",
    channelOperatorText: "Channel Operator",
    costParam: "Commission Rate",
    costRatio: "Commission Parameter Ratio",
    costText: "Commission",
    minimumAmount: "Minimum Amount",
    statusText: "State",
    areaNumberText: "Area Number",
    smsTypeText: "Sms Type",
    weightingText: "Weighting",
    numberRandomText: "Random Number",
    numberFixationText: "Fixed Number",
    descriptionText: "Description",
    remarkText: "Remark",
    copyAgentCostText: "Copy Agent Cost",
    sourceAgentNameText: "Source Agent",
    targetAgentNameText: "Target Agents"
  },
  organization: {
    channelText: "Channel",
    channelNameText: "Channel Name",
    costNameText: "Cost Name",
    channelOperatorText: "Channel Operator",
    costText: "Cost",
    minimumAmount: "Minimum Amount",
    statusText: "State",
    areaNumberText: "Area Number",
    smsTypeText: "Sms Type",
    weightingText: "Weighting",
    numberRandomText: "Random Number Caller",
    numberFixationText: "Fixed Number Caller",
    descriptionText: "Description",
    remarkText: "Remark",
    organizationNameText: "Organization",
    organizationCodeText: "Organization Code",
    copyOrganizationCostText: "Copy Organization Cost",
    sourceOrganizationNameText: "Source Organization",
    targetOrganizationNameText: "Target Organizations",
    changeAgentText: "Change Agent",
    originAgentNameText: "Origin Agent",
    targetAgentNameText: "Target Agent",
    viewOrgDetailText: 'View API Detail'
  },
  channel: {
    operatorText: "Operator",
    lastLoginTimeText: "Last Login Time",
    channelIdText: "Channel Id",
    channelNameText: "Channel Name",
    protocolTypeText: "Protocol Type",
    enableChannelText: "Channel State",
    configurePropertyText: "Configure Property",
    configureCostText: "Configure Cost",
    testingChannelText: "Testing Channel",
    numberPoolText: "Number Pool",
    updateNumberPoolText: "Update number pool",
    fixedCallingNumberText: "Fixed Calling Number",
    updateFixedCallingNumberText: "Update fixed calling number",
    connectionStatusText: "Connection Status",
    implementClassText: "Implement Class",
    waitingSubmitAmountText: "Waiting Submit Amount",
    remainingSubmitAmountText: "Remaining Submit Amount",
    failNumberAmountText: "Fail Number Amount",
    weightingText: "Weighting",
    remarkText: "Remark",
    creatorText: "Creator",
    channelCodeText: "Channel Code",
    regionRestrictionText: "Region Restriction",
    operatorRestrictionText: "Operator Restriction",
    combinedRestrictionText: "Combined Restriction",
    supportRegionText: "Support Region",
    descriptionText: "Description",
    dailyMaximumSubmitAmountText: "Daily Maximum Submit Amount",
    IPAddressText: "IP Address",
    portText: "Port",
    APINumberText: "API Number",
    passwordText: "Password",
    APITypeText: "API Type",
    versionText: "Version",
    codingTypeText: "Coding Type",
    codingSchemeText: "Coding Scheme",
    connectionNumberText: "Connection Number",
    speedText: "Speed (Message/second)",
    deliveredSpeedText: "Delivered Speed (Message/second)",
    channelPropertyText: "Channel Property ( ",
    protocolText: " protocol)",
    smsTypeText: "SMS Type",
    costNameText: "Cost Name",
    costText: "Cost",
    channelOperatorText: "Channel Operator",
    attributeValueText: "Attribute Value",
    organizationCodeText: "Organization Code",
    gatewayTypeText: "Gateway Type",
    channelStatusText: "Channel Status",
    settleDayText: "Settle Day",
    minimumAmountText: "Minimum Amount",
    maximumAmountText: "Maximum Amount",
    requestUrlText: "Request URL",
    channelCostText: "Channel Cost",
    callbackUrlText: "Callback Url",
    tradeIDText: "Trade ID",
    signatureKeyText: "Signature Key",
    encryptedKeyText: "Encrypted Key",
    groupNameText: "Group Name",
    addGroupText: "Add Group",
    updateGroupText: "Update Group",
    updateGroupMemberText: "Update Group Member",
    organizationText: "Organization",
    organizationNameText: "Organization Name",
    smsChannelGroupNameText: "Channel Group Name",
    smsChannelGroupStateText: "Channel Group State",
    configureChannelText: "Add Channel",
    addOrganizationCostText: "Add Organization Cost",
    channelGroupDeleteGroupRemark: "Add Cost Package",
    configureGroupCostMemberText: "Add Organization Cost Package",
    forceOperation: 'Force executed',
    channelOperationText: "Channel Operation",
    addChannelText: "Add Channel",
    batchDeleteChannelText: "Batch Delete Channel",
    startChannelText: "Start Channel",
    pauseChannelText: "Pause Channel",
    disableChannelText: "Disable Channel",
    copyChannelCostText: "Copy Cost",
    sourceChannelNameText: "Source Channel",
    targetChannelNameText: "Target Channels",
    batchUpdateCostText: "Batch Update Cost",
    batchUpdateAllCostText: "Batch Update All Cost",
    payChannelId: "Pay Channel Id",
    payChannelNameText: "Pay Channel Name",
    currencyText: "Currency",
    netwayCodeText: "Netway Code",
    defaultCurrencyText: "Default Currency",
    minAmountText: "Minimum Recharge Amount",
    currencyFromText: "Currency From",
    currencyToText: "Currency To",
    currencyRateText: "Exchange Rate",
    currencyExchangeRateUpdateStateText: "Exchange Rate API Update State",
    updateTimeText: "Update time",
    addCurrencyExchangeRateText: "Add Currency Exchange Rate",
    updateCurrencyExchangeRateText: "Update Currency Exchange Rate",
    batchUpdateCurrencyExchangeRateText: "Batch Update Currency Exchange Rate",
    createSimilarChannelText: "Create Similar Channels"
  },
  warningMessage: {
    updateInformationMessage: "Please select the records to be updated",
    selectRecordToDeleteMessage: 'Please select the records to delete ',
    deleteRecordMessage: 'Delete Record',
    deleteRecordConfirmMessage: 'Are you confirm to delete that record？',
    selectPhoneToDeleteMessage: 'Please select phone number to delete ',
    deletePhoneMessage: 'Delete Phone Number',
    deletePhoneConfirmMessage: 'Are you confirm to delete phone number',
    batchDeletePhoneMessage: "Batch Delete Phone Number",
    batchDeletePhoneConfirmMessage: "Are you confirm to batch delete that phone number?",
    selectSensitiveWordToDeleteMessage: 'Please select sensitive word to delete ',
    deleteSensitiveWordMessage: 'Delete Sensitive Word',
    deleteSensitiveWordConfirmMessage: 'Are you confirm to delete sensitive word',
    batchDeleteSensitiveWordMessage: "Batch Delete Sensitive Word",
    batchDeleteSensitiveWordConfirmMessage: "Are you confirm to batch delete that sensitive word?",
    deleteRecordSuccessMessage: 'Delete successfully',
    addInformationSuccessMessage: 'Add information successfully',
    selectRecordToResubmitMessage: 'Please select the records to be resubmitted',
    enterValidParamToResubmitMessage: 'Please enter valid search parameter to resubmit SMS',
    resubmitSMSMessage: "Are you confirm to resubmit",
    resubmitSMSMessage2: "SMS?",
    resubmitSMSTitle: "Resubmit SMS",
    resubmit2RecordTitle: "Reissue record",
    resubmit2RecordRemarkMessage: "Confirm to reissue the record？",
    selectRecordToResubmitNoticeMessage: 'Please select the records to resend notice',
    resubmitRemarkNoticeTitle: 'Resend Notice',
    resubmitRemarkNoticeMessage: 'Are you confirm to resend state notice? Record which has its state not equal to sorting fail, receive successfully, receive fail, will not be resent!',
    resubmitRemarkTitle: 'Resubmit Record',
    resubmitRemarkMessage: 'Are you confirm to resubmit that record? Record which has its state not equal to sorting fail, receive successfully, receive fail, will not be resent!',
    conditionalUpdateRemarkTitle: "Force Update",
    conditionalUpdateRemarkMessage: "Are you confirm to update the state of those records which fulfilled the search parameter?",
    selectRecordToAuditMessage: 'Please select the records to be audited',
    auditRecordMessage: 'Audit Record',
    auditRecordConfirmMessage: 'Are you confirm to audit that record?',
    refuseReasonConfirmMessage: 'Please enter refuse reason, and confirm',
    auditSuccessMessage: 'Audit successfully',
    cannotBeEmpty: 'Cannot be NULL',
    enterChannelNameMessage: 'Please enter channel name',
    enterChannelCodeMessage: 'Please enter channel code',
    enterWeightingMessage: 'Please enter weighting',
    enterImplementClassMessage: 'Please enter channel implement class',
    enterRegionRestrictionRegexMessage: 'Please enter regular expression for region restriction',
    enterOperatorRestrictionRegexMessage: 'Please enter regular expression for operator restriction',
    enterCombinedRestrictionRegexMessage: 'Please enter regular expression for combined region and operator restriction',
    enterDescriptionMessage: 'Please enter description',
    enterDailySubmitAmountMessage: 'Please enter daily submit amount',
    pleaseSelectOneChannelMessage: "Please select ONE channel ONLY.",
    configureChannelPropertyMessage: "Please select channel for property configuration",
    configureChannelCostMessage: "Please select channel for channel cost configuration",
    updatePropertyMessage: "Update Channel Property",
    updateCostMessage: 'Update Channel Cost',
    addJobConfirmMessage: 'Are you confirm to add selected job(s)?',
    addJobSuccessMessage: 'Add Job Successfully',
    selectJobToDeleteMessage: "Please select job to be deleted",
    deleteJobConfirmMessage: 'Are you confirm to delete selected job(s)?',
    deleteJobSuccessMessage: 'Delete Job Successfully',
    selectJobToPauseMessage: "Please select job to be paused",
    pauseJobConfirmMessage: 'Are you confirm to pause selected job(s)?',
    pauseJobSuccessMessage: 'Pause Job Successfully',
    selectJobToResumeMessage: "Please select job to be resumed",
    resumeJobConfirmMessage: 'Are you confirm to resume selected job(s)?',
    resumeJobSuccessMessage: 'Resume Job Successfully',
    selectJobToRunMessage: "Please select job to be run",
    runJobConfirmMessage: 'Are you confirm to run selected job(s)?',
    runJobSuccessMessage: 'Run Job Successfully',
    enterNumberMessage: 'Please enter phone number or upload number document',
    uploadDynamicVariableDocumentMessage: "Please upload dynamic variable document",
    channelCostExistMessage: 'Cost is already configured. Cannot add again',
    selectGroupToUpdateMessage: "Please select the groups to update",
    selectUpdateTemplateMessage: "Please select the templates to be updated",
    selectMessageToDeleteMessage: 'Please select messages for schedule cancelling',
    cancelScheduleRemarkMessage: 'Submit immediately?',
    cancelScheduleRemarkForConfirmMessage: 'Submit Messages: Submit all messages in send box which are approved after audit',
    cancelScheduleRemarkForCancelMessage: 'Cancel Schedule: Cancel Schedule and discard this message',
    cancelScheduleSuccessMessage: "Cancel Schedule Successfully",
    addSensitiveWordSuccessMessage: "Add Sensitive Word Successfully",
    sensitiveWordNoInputMessage: "No input",
    addPhoneNumberBlackListText: 'Add Phone Number To Black List',
    addBlackListSuccessMessage: 'Add Phone Number To Black List Successfully',
    addTemplateSuccessMessage: 'Add Template Successfully',
    importTemplateSuccessMessage: 'Import Template Successfully',
    updateTemplateSuccessMessage: 'Update Template Successfully',
    deleteTemplateMessage: 'Delete Template',
    deleteTemplateConfirmMessage: 'Are you confirm to delete selected template(s)?',
    updateJobSuccessMessage: "Update Job Successfully",
    deleteGroupMessage: "Delete Group",
    deleteGroupConfirmMessage: "Are you confirm to delete selected group(s)?",
    updateGroupMessage: "Update Group",
    updateGroupConfirmMessage: "Are you confirm to update selected group(s)?",
    addGroupSuccessMessage: "Add Group Successfully",
    updateGroupSuccessMessage: "Update Group Successfully",
    updateGroupDetailSuccessMessage: "Update Group Member Successfully",
    updateGroupStatusSuccessMessage: "Update Group Status Successfully",
    selectChannelToDeleteMessage: "Please select the channel(s) to delete",
    deleteChannelMessage: "Delete Channel",
    deleteChannelConfirmMessage: "Are you confirm to delete selected channel(s)?",
    selectChannelToStartMessage: "Please select the channel(s) to start",
    startChannelMessage: "Start Channel",
    startChannelConfirmMessage: "Are you confirm to start selected channel(s)?",
    startChannelSuccessMessage: "Start Channel Successfully",
    selectChannelToPauseMessage: "Please select the channel(s) to pause",
    pauseChannelMessage: "Pause Channel",
    pauseChannelConfirmMessage: "Are you confirm to pause selected channel(s)?",
    pauseChannelSuccessMessage: "Pause Channel Successfully",
    selectChannelToDisableMessage: "Please select the channel(s) to disable",
    disableChannelMessage: "Disable Channel",
    disableChannelConfirmMessage: "Are you confirm to disable selected channel(s)?？",
    disableChannelSuccessMessage: "Disable Channel Successfully",
    addChannelSuccessMessage: "Add Channel Successfully",
    updateChannelSuccessMessage: "Update Channel Successfully",
    deleteChannelSuccessMessage: "Delete Channel Successfully",
    addChannelPropertySuccessMessage: "Add Channel Property Successfully",
    updateChannelPropertySuccessMessage: "Update Channel Property Successfully",
    updateNumberPoolSuccessMessage: "Update Number Pool Successfully",
    updateNumberFixationSuccessMessage: "Update Number Fixation Successfully",
    addChannelCostSuccessMessage: "Add Channel Cost Successfully",
    updateChannelCostSuccessMessage: "Update Channel Cost Successfully",
    deleteChannelCostMessage: "Delete channel cost",
    deleteChannelCostConfirmMessage: "Confirm to delete this channel cost?",
    addPayChannelSuccessMessage: "Add Pay Channel Successfully",
    updatePayChannelSuccessMessage: "Update Pay Channel Successfully",
    selectPayChannelToDeleteMessage: "Please select pay channel(s) to delete",
    selectPayChannelToCopy: "Please select one pay channel to copy",
    deletePayChannelMessage: "Delete Pay Channel",
    deletePayChannelConfirmMessage: "Are you confirm to delete selected pay channel(s)?",
    deletePayChannelSuccessMessage: "Delete Pay Channel Successfully",
    submitSMSMessage: "Submit SMS Message",
    submitSMSConfirmMessage: "Are you confirm to submit sms message(s)?",
    submitScheduledSMSMessage: "Submit Scheduled SMS Message",
    submitScheduledSMSConfirmMessage: "Are you confirm to submit Scheduled  message(s)?",
    fileExceedMessage: "Upload file exceed limit",
    fileExceedLimitMessage: "The limit is ",
    fileSizeExceedMessage: "Upload file size exceed limit",
    fileSizeExceedLimitMessage: "The file size limit is ",
    submitSMSSuccessMessage: "Submit SMS Message Success",
    submitScheduledSMSSuccessMessage: "Submit Scheduled SMS Message Success",
    uploadInvalidFileFormatMessage: "Uploaded file format was invalid, please upload valid file",
    forceLogoffMessage: "Force Logoff User",
    forceLogoffConfirmMessage: "Are you confirm to force logoff that user?",
    forceLogoffSuccessMessage: "Force Logoff User",
    removeGoogleMessage: "Clear user google code",
    removeGoogleConfirmMessage: "Are you confirm to clear google code?",
    removeGoogleSuccessMessage: "Clear google code success",
    selectUserToUpdatePermissionMessage: "Please select user(s) to update.",
    updatePermissionMessage: "Update User Permission",
    updatePermissionConfirmMessage: "Are you confirm to update user permission?",
    updatePermissionSuccessMessage: "Update User Permission Successfully",
    batchUpdatePermissionMessage: "Batch Update User Permission",
    batchUpdatePermissionConfirmMessage: "Are you confirm to batch update user permission?",
    batchUpdatePermissionSuccessMessage: "Batch Update User Permission Successfully",
    selectBlackListToDeleteMessage: "Please select user(s) to delete.",
    deleteBlackListMessage: "Delete Black List",
    deleteBlackListConfirmMessage: "Are you confirm to delete that black list member",
    deleteBlackListSuccessMessage: "Delete Black List Successfully",
    passwordFormatNoUpperMessage: "Password must contain at least one capital letter",
    batchCancelAgentConfirmMessage: "Are you confirm to batch cancel agent(s)?",
    cancelAgentCancelledMessage: "Cancel agent is cancelled",
    cancelAgentSuccessMessage: "Cancel Agent Successfully!",
    cancelOrganizationConfirmMessage: "Are you confirm to cancel organization? ",
    cancelOrganizationConfirmRemarkMessage: "All organization users under that organization will also be cancelled.",
    batchCancelOrganizationConfirmMessage: "Are you confirm to batch cancel organizations?",
    batchCancelOrganizationConfirmRemarkMessage: " All organization users under those organizations will also be cancelled.",
    cancelOrganizationCancelledMessage: "Cancel organization is cancelled",
    cancelOrganizationSuccessMessage: "Cancel Organization Successfully!",
    cancelOrganizationRemarkMessage: "By default, batch operation will not handle remaining available amount of cancelled organizations.",
    cancelOrganizationRemarkMessage1: "If you need to handle remaining available amount of cancelled organizations, please cancel organization specifically.",
    deleteAgentSystemConfigMessage: "Delete Agent System Configuration",
    deleteAgentSystemConfigConfirmMessage: "Are you confirm to delete agent system configuration",
    deleteAgentSystemConfigSuccessMessage: "Delete Agent System Configuration Successfully",
    selectTemplateToSubmitMessage: "Please select template to submit SMS",
    pleaseSelectOneTemplateMessage: "Please select ONE template ONLY.",
    pleaseSelectValidTemplateMessage: "Please select template which audit state is pass",
    pleaseEnterBatchNumberMessage: "Please enter batch number.",
    pleaseSelectLatestSevenDaysMessage: "Please Select Latest Seven Days",
    selectExcelToDownloadMessage: "Please select excel to download",
    pleaseWaitForExportMessage: "Your request is received. The data is under processing. Please wait for a moment. (60s is needed for exporting 500000 messages)",
    pleaseWaitForExportAndNavigateMessage: "Your request is received. The data is under processing. You can download excel in 'Report Management/Export Excel'. (50s is needed for processing 500000 messages) ",
    pleaseWaitForExportAndNavigateTitle: "Export Remark",
    exportAndNavigateConfirmButtonText: "Go",
    exportAndNavigateCancelButtonText: "Noted",
    selectExcelToDeleteMessage: "Please select excel to delete",
    deleteExcelMessage: "Delete Excel",
    deleteExcelConfirmMessage: "Are you confirm to delete excel",
    batchDeleteExcelMessage: "Batch Delete Excel",
    batchDeleteExcelConfirmMessage: "Are you confirm to batch delete excel?",
    excelFormatRemarkMessage1: "The maximum row limitation of xls format is 65536, Support by MS 2003 Excel version and older version",
    excelFormatRemarkMessage2: "The maximum row limitation of xlsx format is 1048576, Not Support by MS 2003 Excel version and older version",
    excelFormatRemarkMessage3: "Default setting is in xlsx format and maximum row limitation with 500,000.",
    invalidRowLimitMessage: "Invalid Row Limit",
    currentExcelSettingMessage: "Current setting:",
    defaultExcelSettingMessage: "Default",
    addExcelSettingSuccessMessage: "Add Excel Setting Success",
    addExcelSettingFailMessage: "Add Excel Setting Fail",
    pleaseWaitForProcessMessage: "Your request is received. The data is under processing. Please wait for a moment.",
    pleaseWaitForProcessSendBoxSubmitMessage: "System is processing your request. Please wait for a moment. Please check send box to see the submitted SMS.",
    pleaseWaitForPreviewContentMessage: "Preview content is preparing now. Please wait for a moment.",
    channelGroupAddMemberRemark: "One organization can join one channel group only. All existing organization costs of that organization will be deleted when the organization join the channel group. All existing organization costs of that channel group will be deleted when that organization joined another channel group before. The state and weighting of all costs will follow corresponding channel.",
    channelGroupDeleteMemberRemark: "All existing organization costs of that organization will be deleted when remove organization from channel group.",
    channelGroupAddChannelRemark: "Channel group can add arbitrary channels, all organizations in that channel group will add organization cost with new added channel.",
    channelGroupDeleteChannelRemark: "All existing organization costs in that channel will be deleted when remove channel from channel group.",
    channelGroupDeleteGroupRemark: "All existing organization costs in that channel group will be deleted when delete channel group.",
    channelGroupAddCostRemark: "Channel group can add arbitrary cost combinations, all organizations in that channel group will add organization cost with new added cost combinations. The state and weighting of all costs will follow corresponding channel.",
    channelGroupAddCostMemberRemark: "One organization can join one channel group only. All existing organization costs of that organization will be deleted when the organization join the channel group. All existing organization costs of that channel group will be deleted when that organization joined another channel group before.",
    channelGroupDeleteCostRemark: "Selected cost combination in all organizations in that channel group will be deleted when remove cost combination from channel group.",
    channelGroupDeleteCostMemberRemark: "All cost combinations from that channel group will be deleted for selected organization when remove organization from channel group.",
    selectChannelGroupMemberMessage: "Please Select Organization",
    selectChannelGroupCostMessage: "Please Select Cost Combinations",
    pleaseSelectSourceOrganizationAndTargetOrganizationMessage: "Please Select Source Organization And Target Organizations",
    copyOrganizationCostSuccessMessage: "Copy Organization Cost Successfully!",
    copyOrganizationCostRemark: "All existing organization costs of target organizations will be deleted when copy the costs from source organization",
    pleaseSelectTargetOrganizationAndTargetAgentMessage: "Please Select Target Organizations And Target Agent",
    changeAgentSuccessMessage: "Change Agent Successfully!",
    changeAgentRemark: "All existing organization costs of target organizations will be deleted when change the agent of target organizations. If organization joined channel group before changing agent, all organizations will be forced removed in channel groups.",
    pleaseSelectSourceAgentAndTargetAgentMessage: "Please Select Source Agent And Target Agents",
    copyAgentCostSuccessMessage: "Copy Agent Cost Successfully!",
    copyAgentCostRemark: "All existing agent costs of target agents will be deleted when copy the costs from source agent",
    pleaseSelectSourceChannelAndTargetChannelMessage: "Please Select Source Channel And Target Channels",
    copyChannelCostSuccessMessage: "Copy Channel Cost Successfully!",
    copyChannelCostRemark: "All existing channel costs of target channels will be deleted when copy the costs from source channel",
    updateTemplateRemarkTitle: "Update Template",
    updateTemplateRemarkMessage: "For 'Send Template Only' user, the audit state will be set to 'Waiting for audit' when updating the content of template",
    selectOrganizationMessage: "Please select organization.",
    selectOneOrganizationMessage: "Please select one organization.",
    HTTPAndSMPPNotAvailableMessage: "SMPP or HTTP API is not available for selected organization.",
    addCurrencyExchangeRateSuccessMessage: "Add Currency Exchange Rate Success",
    updateCurrencyExchangeRateSuccessMessage: "Update Currency Exchange Rate Success",
    selectCurrencyExchangeRateToUpdateMessage: "Please Select Currency Exchange Rate Pair(s)",
    updateCurrencyExchangeRateTitle: "Update To Latest Currency Exchange Rate",
    updateCurrencyExchangeRateMessage: "Are you confirm to update to latest currency exchange rate? " + "All selected currency exchange rate will be updated immediately with latest value, " + "includes those 'API Update State' equals to 'Manual Update'"
  },
  auditOptionsText: {
    waitForAuditText: "Waiting for audit",
    auditVerifiedText: "Audit Verified",
    auditNotVerifiedText: "Audit Not Verified",
    manualAuditText: "Manual Audit"
  },
  informationOptionsText: {
    smsMessageText: "SMS Message"
  },
  statusOptionsText: {
    normalText: "Normal",
    pauseText: "Pause",
    sortingFailText: "Sorting Fail",
    waitingSubmitUpstreamText: "Waiting Submit",
    submitSuccessText: "Submit Success",
    submitFailText: "Submit Fail",
    receiveSuccessText: "Receive Success",
    receiveFailText: "Receive Fail"
  },
  submitMethodOptionText: {
    backendSubmitText: 'Organization Backend',
    httpSubmitText: 'HTTP API',
    smppSubmitText: 'SMPP API'
  },
  submitNumberMethodOptionText: {
    submitByFormText: 'Submit By Form',
    submitByExcelTemplateText: 'Submit By Excel Template'
  },
  numberRegionOptionsText: {
    china: "Mainland China",
    hongKong: "Hong Kong",
    international: "International"
  },
  smsChannelNameOptionText: {
    httpProtocolText: "http protocol",
    smppProtocolText: "smpp protocol"
  },
  smsChannelStatusOptionText: {
    enableText: "Enable",
    pauseText: "Pause",
    disableText: "Disable"
  },
  smsChannelConnectionStatusOptionText: {
    connectionSuccessText: "Connected",
    connectionFailText: "Not yet connected"
  },
  forceBindGoogleOptionText: {
    freeText: "Free to bind",
    forceText: "Forced to bind"
  },
  storedGoogleStatusOptionText: {
    noneText: "None",
    storedText: "Bound"
  },
  checkNumberCountOptionText: {
    noAuditText: "No audit",
    auditText: "Audit"
  },
  activeUserOptionText: {
    activeText: "Active User",
    inactiveText: "Inactive User"
  },
  booleanStateOptionText: {
    noText: "No",
    yesText: "Yes"
  },
  googleCodeRemarkMessage: {
    googleCodeRemarkTitle: "Bind Google Verification Code Remark",
    googleCodeRemarkMessage: "Please bind Google verification code, it is necessary for next login.",
    confirmButtonText: "Bind now",
    cancelButtonText: "Noted"
  },
  serverNotRespond: {
    serverNotRespondTitle: "Server No Respond",
    serverNotRespondMessage: "Server is not responding, will be redirected to login page",
    confirmButtonText: "Re-login"
  },
  loginBlackList: {
    roleText: "Role",
    agentText: "Agent",
    agentNameText: "Agent Name",
    organizationUserText: "Organization User",
    organizationUserNameText: "Organization User Name"
  },
  exportedExcel: {
    userNameText: "Username",
    roleText: "Role",
    serviceNameText: "Service Name",
    fileNameText: "Filename",
    statusText: "Status",
    remarkText: "Remark",
    creatorText: "Creator",
    createTimeText: "Create Time",
    updateExportedExcelTitle: "Update Excel Remark",
    downloadText: "Download",
    batchDownloadText: "Batch Download"
  },
  exportedExcelServiceName: {
    sendBoxNoUseNumber: "Send Box No Use Number",
    sendBox: "Send Box",
    sendRecord: "Send Record",
    returnRecord: "Return Record",
    sendBoxHistory: "History Send Box",
    sendRecordHistory: "History Send Record",
    returnRecordHistory: "History Return Record",
    statisticalAgent: "Statistical Agent Daily Report",
    statisticalMonAgent: "Statistical Agent Monthly Report",
    statisticalChannel: "Statistical Channel Daily Report",
    statisticalMonChannel: "Statistical Channel Monthly Report",
    statisticalChannelOperator: "Statistical Channel Operator Daily Report",
    statisticalMonChannelOperator: "Statistical Channel Operator Monthly Report",
    statisticalConsumeAmount: "Statistical Consume Amount Daily Report",
    statisticalMonConsumeAmount: "Statistical Consume Amount Monthly Report",
    statisticalOrgCode: "Statistical OrgCode Daily Report",
    statisticalMonOrgCode: "Statistical OrgCode Monthly Report",
    statisticalGeneral: "Statistical General Daily Report",
    statisticalRateSuccess: "Statistical Rate Success Report",
    statisticalTotalDaily: "Total Daily",
    statisticalAllConsumeAmount: "Statistical All Consume Amount Daily Report",
    statisticalMonAllConsumeAmount: "Statistical All Consume Amount Monthly Report",
    MSGID: "MSGID",
    sortingFail: "Sorting Fail Report"
  },
  placeholder: {
    verificationCode: "Please enter Google verification code"
  },
  roleOptionsText: {
    adminText: "Admin",
    agentText: "Agent",
    organizationText: "Organization"
  },
  excelStatusOptionsText: {
    availableText: "Available",
    unavailableText: "Unavailable"
  },
  excelFormatOptionText: {
    xls: "xls",
    xlsx: "xlsx"
  },
  smsNumberTypeOptionText: {
    formSubmitText: "Submit By Form",
    excelSubmitText: "Submit By Excel"
  },
  numberAreaProvince: {
    BeiJing: "Beijing",
    Tianjin: "Tianjin",
    HeBei: "Hebei",
    LiaoNing: "Liaoning",
    JiLin: "Jilin",
    HeiLongJiang: "Heilongjiang",
    ShanDong: "Shandong",
    JiangSu: "Jiangsu",
    ShangHai: "Shanghai",
    ZheJiang: "Zhejiang",
    AnHui: "Anhui",
    FuJian: "Fujian",
    JiangXi: "Jiangxi",
    GuangDong: "Guangdong",
    GuangXi: "Guangxi",
    HaiNan: "Hainan",
    HeNan: "Henan",
    HuNan: "Hunan",
    HuBei: "Hubei",
    ShanXi: "Shanxi",
    NeiMengGu: "Inner Mongolian",
    NingXia: "Ningxia",
    QingHai: "Qinghai",
    ShanXiS: "Shaanxi",
    GanSu: "Gansu",
    XinJiang: "Xinjiang",
    SiChuan: "Sichuan",
    GuiZhou: "Guizhou",
    YunNan: "Yunnan",
    ChongQing: "Chongqing",
    XiZang: "Tibet"
  },
  smsNumberArea: {
    UnitedStates: "United States",
    Canada: "Canada",
    CanadaAndUnitedStates: "Canada/United States",
    China: "China",
    HongKong: "Hong Kong",
    Macao: "Macao",
    Taiwan: "Taiwan",
    Malaysia: "Malaysia",
    Indonesia: "Indonesia",
    Philippines: "Philippines",
    Singapore: "Singapore",
    Thailand: "Thailand",
    Brunei: "Brunei",
    Japan: "Japan",
    SKorea: "Korea",
    Vietnam: "Vietnam",
    NKorea: "Korea",
    Cambodia: "Cambodia",
    Laos: "Laos",
    Bangladesh: "Bangladesh",
    Turkey: "Turkey",
    India: "India",
    Pakistan: "Pakistan",
    Afghanistan: "Afghanistan",
    SriLanka: "Sri Lanka",
    Myanmar: "Myanmar",
    Maldives: "Maldives",
    Lebanon: "Lebanon",
    Jordan: "Jordan",
    Syria: "Syria",
    Iraq: "Iraq",
    Kuwait: "Kuwait",
    SaudiArabia: "Saudi Arabia",
    Oman: "Oman",
    Israel: "Israel",
    Bahrain: "Bahrain",
    Qatar: "Qatar",
    Bhutan: "Bhutan",
    Mongolia: "Mongolia",
    Nepal: "Nepal",
    Iran: "Iran",
    Russia: "Russia",
    Greece: "Greece",
    Netherlands: "Netherlands",
    Belgium: "Belgium",
    France: "France",
    Spain: "Spain",
    Gibraltar: "Gibraltar",
    Portugal: "Portugal",
    Luxembourg: "Luxembourg",
    Ireland: "Ireland",
    Iceland: "Iceland",
    Albania: "Albania",
    Malta: "Malta",
    Cyprus: "Cyprus",
    Finland: "Finland",
    Bulgaria: "Bulgaria",
    Hungary: "Hungary",
    Germany: "Germany",
    Yugoslavia: "Yugoslavia",
    Italy: "Italy",
    SanMarino: "San Marino",
    Vatican: "Vatican",
    Romania: "Romania",
    Switzerland: "Switzerland",
    Liechtenstein: "Liechtenstein",
    Austria: "Austria",
    UnitedKingdom: "United Kingdom",
    Denmark: "Denmark",
    Sweden: "Sweden",
    Norway: "Norway",
    Poland: "Poland",
    Egypt: "Egypt",
    Morocco: "Morocco",
    Algeria: "Algeria",
    Tunisia: "Tunisia",
    Libya: "Libya",
    Gambia: "Gambia",
    Senegal: "Senegal",
    Mauritania: "Mauritania",
    Mali: "Mali",
    Guinea: "Guinea",
    CotedIvoire: "Cote d'Ivoire",
    BurkinaFaso: "Burkina Faso",
    Niger: "Niger",
    Togo: "Togo",
    Benin: "Benin",
    Mauritius: "Mauritius",
    Liberia: "Liberia",
    SierraLeone: "Sierra Leone",
    Ghana: "Ghana",
    Nigeria: "Nigeria",
    Chad: "Chad",
    CentralAfrica: "Central Africa",
    Cameroon: "Cameroon",
    CapeVerde: "Cape Verde",
    SaoTome: "Sao Tome",
    Principe: "Principe",
    SaoTomeAndPrincipe: "Sao Tome And Principe",
    EquatorialGuinea: "Equatorial Guinea",
    Gabon: "Gabon",
    Congo: "Congo",
    Zaire: "Zaire",
    Angola: "Angola",
    GuineaBissau: "Guinea-Bissau",
    Ascension: "Ascension",
    Seychelles: "Seychelles",
    Sudan: "Sudan",
    Rwanda: "Rwanda",
    Ethiopia: "Ethiopia",
    Somalia: "Somalia",
    Djibouti: "Djibouti",
    Kenya: "Kenya",
    Tanzania: "Tanzania",
    Uganda: "Uganda",
    Burundi: "Burundi",
    Mozambique: "Mozambique",
    Zambia: "Zambia",
    Madagascar: "Madagascar",
    Reunion: "Reunion",
    Zimbabwe: "Zimbabwe",
    Namibia: "Namibia",
    Malawi: "Malawi",
    Lesotho: "Lesotho",
    Botswana: "Botswana",
    Swaziland: "Swaziland",
    Comoros: "Comoros",
    SouthAfrica: "South Africa",
    StHelena: "St.Helena",
    Aruba: "Aruba",
    FaroeIslands: "Faroe Islands",
    Midwayisland: "Midway island",
    Hawaii: "Hawaii",
    WakeIsland: "Wake Island",
    Anguilla: "Anguilla",
    TheVirginIslands: "The Virgin Islands",
    SaintLucia: "Saint Lucia",
    PuertoRico: "Puerto Rico",
    Jamaica: "Jamaica",
    Bahamas: "Bahamas",
    Barbados: "Barbados",
    Alaska: "Alaska",
    Greenland: "Greenland",
    Belize: "Belize",
    Guatemala: "Guatemala",
    Salvador: "Salvador",
    Honduras: "Honduras",
    Nicaragua: "Nicaragua",
    CostaRica: "Costa Rica",
    Panama: "Panama",
    Haiti: "Haiti",
    Peru: "Peru",
    Mexico: "Mexico",
    Cuba: "Cuba",
    Argentina: "Argentina",
    Brazil: "Brazil",
    Chile: "Chile",
    Colombia: "Colombia",
    Venezuela: "Venezuela",
    Bolivia: "Bolivia",
    Guyana: "Guyana",
    Ecuador: "Ecuador",
    FrenchGuiana: "French Guiana",
    Paraguay: "Paraguay",
    Martinique: "Martinique",
    Suriname: "Suriname",
    Uruguay: "Uruguay",
    Australia: "Australia",
    NewZealand: "new Zealand",
    Guam: "Guam",
    CocosIsland: "Cocos Island",
    NorfolkIsland: "Norfolk Island",
    Christmasisland: "Christmas island",
    Nauru: "Nauru",
    Tonga: "Tonga",
    SolomonIslands: "Solomon Islands",
    Vanuatu: "Vanuatu",
    Fiji: "Fiji",
    CorkIslands: "Cork Islands",
    Niue: "Niue",
    EasternSamoa: "Eastern Samoa",
    WesternSamoa: "Western Samoa",
    Kiribati: "Kiribati",
    Tuvalu: "Tuvalu",
    AntiguaAndBarbuda: "Antigua and Barbuda",
    BritishVirginIslands: "British Virgin Islands",
    USVirginIslands: "US Virgin Islands",
    CaymanIslands: "Cayman Islands",
    Bermuda: "Bermuda",
    Grenada: "Grenada",
    TurksAndCaicosIslands: "Turks & Caicos Islands",
    Montserrat: "Montserrat",
    AmericanSamoa: "American Samoa",
    StMaarten: "St Maarten",
    StLucia: "St Lucia",
    Dominica: "Dominica",
    StVincentAndGrenadines: "St Vincent and Grenadines",
    DominicanRepublic: "Dominican Republic",
    TrinidadAndTobago: "Trinidad and Tobago",
    StKittsAndNevis: "St Kitts and Nevis",
    SouthSudan: "South Sudan",
    DiegoGarcia: "Diego Garcia",
    Eritrea: "Eritrea",
    Lithuania: "Lithuania",
    Latvia: "Latvia",
    Estonia: "Estonia",
    Moldova: "Moldova",
    Armenia: "Armenia",
    Belarus: "Belarus",
    Andorra: "Andorra",
    Monaco: "Monaco",
    Ukraine: "Ukraine",
    Serbia: "Serbia",
    Montenegro: "Montenegro",
    Kosovo: "Kosovo",
    Croatia: "Croatia",
    Slovenia: "Slovenia",
    BosniaAndHerzegovina: "Bosnia & Herzegovina",
    Macedonia: "Macedonia",
    CzechRepublic: "Czech Republic",
    Slovakia: "Slovakia",
    Yemen: "Yemen",
    Palestine: "Palestine",
    UAE: "UAE",
    Tajikistan: "Tajikistan",
    Turkmenistan: "Turkmenistan",
    Azerbaijan: "Azerbaijan",
    Georgia: "Georgia",
    Kyrgyzstan: "Kyrgyzstan",
    Uzbekistan: "Uzbekistan",
    EastTimor: "East Timor",
    PapuaNewGuinea: "Papua New Guinea",
    Palau: "Palau",
    WallisFutuna: "Wallis Futuna",
    NewCaledonia: "New Caledonia",
    FrenchPolynesia: "French Polynesia",
    Tokelau: "Tokelau",
    Micronesia: "Micronesia",
    MarshallIslands: "Marshall Islands",
    Inmarsat: "Inmarsat",
    FalklandIslands: "Falkland Islands",
    StPierreAndMiquelon: "St Pierre and Miquelon",
    Guadeloupe: "Guadeloupe"
  },
  rechargeState: {
    orderState: 'Order State',
    createFail: 'Create Fail',
    createSuccess: 'Create Success',
    submitFail: 'Submit Fail',
    submitSuccess: ' Submit Success',
    notifyFail: 'Feedback Fail',
    notifySuccess: 'Feedback Success',
    refund: 'Refund',
    credited: 'Credited'
  },
  refundOrder: {
    orderState: 'Order State',
    rechargeOrderNumber: 'Recharge Order Number',
    refundAmountText: "Refund Amount",
    refundReasonText: "Refund Reason",
    netWayCodeText: "Recharge Type"
  },
  rechargeNotify: {
    notifyTypeText: 'Notify Type'
  },
  refundOrderState: {
    receiveSuccess: 'Receive Success',
    receiveFail: 'Receive Fail',
    submitSuccess: 'Submit Success',
    submitFail: 'Submit Fail',
    refundSuccess: 'Refund Success',
    refundFail: 'Refund Fail'
  },
  currencyExchangeRateUpdateState: {
    apiUpdateText: 'API Update',
    manualUpdateText: 'Manual Update'
  },
  notifyType: {
    rechargeOrderNotifyText: 'Recharge Order Notify',
    refundOrderNotifyText: 'Refund Order Notify'
  },
  agentRemitOrder: {
    accountNo: 'Account/Mobile',
    bank: 'Bank',
    alipay: 'Alipay',
    weChat: 'WeChat',
    accountName: 'Account Name',
    rejectReason: 'reject Reason',
    withdrawCurrency: 'Withdraw Currency Type',
    amountAfterConversion: 'Amount After Conversion',
    amountAfterConversionForTable: 'Withdrawal Amount For relate Currency',
    rate: 'Exchange Rate',
    accountDetail: 'Account Details'
  },
  agentAmountChangeRecord: {
    reasonForChangeInAmount: 'Amount Change Reason',
    effectiveAmountBeforeOperation: 'Available Amount Before',
    changeEffectiveAmount: 'Available Amount Changed',
    effectiveAmountAfterOperation: 'Available Amount After',
    amountToBeCreditedBeforeOperation: 'Uncredited Amount Before',
    changesToTheAmountToBeRecorded: 'Uncredited Amount Changed',
    amountToBeCreditedAfterOperation: 'Uncredited Amount After'
  },
  rechargeOrderNotify: {
    getRequestSent: 'Request Sent'
  },
  rechargeOrderRecord: {
    channelName: 'Channel Name',
    channelID: 'Channel ID'
  }
};
exports.default = _default;